import { Component, OnInit, Input, ViewChild, ElementRef, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
// import { NgForm } from '@angular/forms';

import { ModalService } from './modal.service';
import { GlobalService } from '../../services/global.service';
import { SnackBarService } from '../snackbar/snackbar.service';

import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { Advisor } from '../../models/advisor';
import { Client } from '../../models/client';
import { Organization } from '../../models/organization';

import Utils from '../utility';
import { RequestOptions } from '@angular/http';

import { IMyDpOptions, IMyDateModel, IMyDate } from 'mydatepicker';

// import { UploadOutput, UploadInput, UploadFile, humanizeBytes, UploaderOptions, UploadStatus } from 'ngx-uploader';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css'],
  encapsulation: ViewEncapsulation.None,
  host: {
    '(document:click)': 'onClick($event)',
  }
})

export class ModalComponent implements OnInit {

  public dateofBirth;
  public currentYear;
  public yob;
  public endYear1;
  public endYear2;
  public endOfPIAStartYear;
  public endOfPIAEndYear;
  public age;
  public showAge;
  public min;
  public maxAge;
  public minAge;

  public spouseDateofBirth;			
	public spouseYob;
	public spouseEndOfPIAStartYear;
	public spouseEndYear1;
	public spouseEndYear2;
  public spouseEndOfPIAEndYear;
  public spouseShowAge;
  public spouseMinAge;
  public spouseMaxAge;
  public SpouseMin;

  public ageEighteen;
  public eighteenYearsAgo;
  private today = new Date();

  @ViewChild('container') container: ElementRef;
  @ViewChild('scrollEl') scrollEl: ElementRef;
  private selDate: IMyDate = { year: 0, month: 0, day: 0 };
  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: "mm/dd/yyyy",
    editableDateField: true,
    showTodayBtn: false,
    /*   disableUntil: { year: 1930, month: 1, day: 1 },
      disableSince: { year: 2000, month: 1, day: 1 } */
    disableUntil: { year: 1930, month: 1, day: 1 },
    disableSince: {year: this.today.getFullYear() - 18, month: this.today.getMonth() + 1 , day: this.today.getDate() + 1}   

  };

  public myDatePickerOptionsAnn: IMyDpOptions = {
    // other options...
    dateFormat: "mm/dd/yyyy",
    editableDateField: true,
    showTodayBtn: false,
    disableUntil: { year: 1940, month: 1, day: 1 },
    disableSince: { year: 2020, month: 1, day: 1 }
  };

  // Initialized to specific date (09.10.2018).
  public defaultDateModel: any = { date: { year: 1960, month: 1, day: 1 } };

  public currentAddEditClientScreen: Number = 0;
  public previousAddEditClientScreen: Number = 0;

  public selectedDocFilePath: string;
  public selectedDocEvent: any;
  public selectedDocCategory: string;


  public selectedDocument: any = {
    title: '',
    description: '',
    category: '',
  }

  public healthInformationInfo: string = "These inputs will impact life expectancy projections (see below), which is featured within every illustration and report, as well as annual out-of-pocket health care costs.";

  public validFormInputs: any = [
    { isValid: false },
    { isValid: false },
    { isValid: false },
    { isValid: false },
    { isValid: false },
    { isValid: false },
    { isValid: false },
    { isValid: false },
  ];

  public clientModal: any = {
    generalInformation: {
      generalInformation: {
        firstName: '',
        lastName: '',
        gender: '',
        dob: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        phone: '',
        email: '',
      },
      anticipatedRetirementInformation: {
        retirementAge: '',
        retirementState: '',
      },
    },
    financialInformation: {
      PIAYears: {
        IncludePIA: false,
        StartYear: '',
        EndYear: '',
        Years: []
      },
      hasPension: false,
    },
    maritalStatus: {
      firstName: '',
      lastName: '',
    },
    healthConditions: {},
    currentMaritalStatus: {},
    maritalHistory: {
      previouslyMarried: {},

    },
    spouses: [
      { firstName: '', lastName: '' }
    ],
    dependentChildren: {},
  }

  prepSpouses(count) {
    // //console.log(count);
    this.clientModal.maritalHistory.spouses = new Array(count);
  }

  handlePrint(e) {
    window.print();
  }

  prepSpousesSpouse(count) {
    this.clientModelV2.maritalHistory.spousesSpouse = [];

    for (var i = 0; i < count; i++) {
      if (this.clientModelV2.maritalHistory.spousesSpouse[i]) {
        this.clientModelV2.maritalHistory.spousesSpouse.push(this.clientModelV2.maritalHistory.spousesSpouse[i]);
      } else {
        this.clientModelV2.maritalHistory.spousesSpouse.push({
          tenyears: false,
          alive: true,
        });
      }
    }

    ////console.log(this.clientModelV2);
  }

  prepChildren(count) {
    this.clientModelV2.dependentChildren.children = [];

    for (var i = 0; i < count; i++) {
      this.clientModelV2.dependentChildren.children.push({
        DependentChildAge: 0,
      })
    }
  }

  dissabledConinueBtn: boolean = false;
  updateAddEditClientScreen(page) {
    // //console.log(this.selectedAdvisor);
    if (page == -1) {
      this.isSelectingAdvisor = false;

      this.advisors.forEach((a) => {
        if (a.c.ID == this.selectedAdvisor) {
          this.selectedAdvisor = a;
        }
      });

      // //console.log(this.selectedAdvisor);

      this.validateFields(page);
      return;
    }
    // //console.log('PAGE:', page);

    if (page == 4) {
      this.dissabledConinueBtn = true;
    } else {
      this.dissabledConinueBtn = false;
    }

    if (page !== this.currentAddEditClientScreen) {
      this.previousAddEditClientScreen = this.currentAddEditClientScreen;
      this.currentAddEditClientScreen = page;
      this.validateFields(page);
    }
  }

  uploadFileChanged(e) {
    this.selectedDocEvent = e;
    this.selectedDocFilePath = e.target.files[0].name;
  }

  test(e) {
    // //console.log(e);
  }

  /*   public ageCheck(): void {   
      this.birthdate;
      if (this.birthdate) {
        var timeDiff = Math.abs(Date.now() - new Date(this.birthdate).getTime());
        this.age = Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);
        console.log(this.age)
  
        if (this.age >= 18) {
          console.log("Age greater than 18")
        } else {
          console.log("Age less than 18")
        }
      }
    } */

  validateAge() {
    var eighteenYearsAgo = new Date();
    this.eighteenYearsAgo = eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 18);
    this.ageEighteen = eighteenYearsAgo.getFullYear();
  }


  validateDefaultDate: boolean;
  validateDefaultDate2: boolean;  

  validateFields(page) {
    ////console.log('on this page:', page);
    // //console.log(this.clientModelV2);
    // here
    //this.validateDefaultDate = false;
    var isValid = true;  


    if (page === -1) {
      if (this.clientModelV2.generalInformation.dob === undefined || this.clientModelV2.generalInformation.dob === '') {
        //this.validateDefaultDate = true;
        //this.clientModelV2.generalInformation.dob = this.defaultDOB;
        //this.clientModelV2.generalInformation.dobStr = this.defaultDOBStr;//this.clientModelV2.generalInformation.dob;
      } else {
        //isValid = isValid && this.clientModelV2.generalInformation.dobStr.length > 0;
       this.validateDefaultDate = this.validateDate(this.clientModelV2.generalInformation.dobStr, true);  
      }

    }
    if (page === 0) {
      isValid = isValid && this.clientModelV2.generalInformation.firstName.length > 0;
      isValid = isValid && this.clientModelV2.generalInformation.lastName.length > 0;
      isValid = isValid && (this.clientModelV2.generalInformation.gender == 1 || this.clientModelV2.generalInformation.gender == 2);
      //isValid = isValid && this.clientModelV2.generalInformation.dobStr.length > 0;      
      if (this.clientModelV2.generalInformation.dob === undefined || this.clientModelV2.generalInformation.dob === '' || this.clientModelV2.generalInformation.dob === this.defaultDOB) {
        //this.validateDefaultDate = true;
        //this.clientModelV2.generalInformation.dob = this.defaultDOB;
        //this.clientModelV2.generalInformation.dobStr = this.defaultDOBStr;//this.clientModelV2.generalInformation.dob;

        isValid = false;

      } else {  
        isValid = isValid && this.clientModelV2.generalInformation.dobStr && this.clientModelV2.generalInformation.dobStr.length > 0;
        this.validateDefaultDate = this.validateDate(this.clientModelV2.generalInformation.dobStr, true);
        
      }


 if (page === 0) {
  isValid = isValid && this.clientModelV2.healthInformation && this.clientModelV2.healthInformation.lifeExpectancy && this.clientModelV2.healthInformation.lifeExpectancy > 0;

  if (isValid) {
    if (this.clientModelV2.maritalStatus && this.clientModelV2.maritalStatus.maritalStatus === 'Single') {
      isValid = true;
    } else if (this.clientModelV2.maritalStatus && this.clientModelV2.maritalStatus.maritalStatus === 'Married') {

      if (this.clientModelV2.maritalStatus.dob === undefined) {
        this.validateDefaultDate = true;

      } else {
        isValid = isValid && this.clientModelV2.maritalStatus.dobStr && this.clientModelV2.maritalStatus.dobStr.length > 0;
        this.validateDefaultDate2 = isValid && this.validateDate(this.clientModelV2.maritalStatus.dobStr, true);
      }
      isValid = isValid && this.clientModelV2.maritalStatus.firstName != "";
      isValid = isValid && this.clientModelV2.maritalStatus.lastName != "";
      isValid = isValid && this.clientModelV2.maritalStatus.anniversaryStr && this.clientModelV2.maritalStatus.anniversaryStr.length > 0;
      isValid = isValid && this.clientModelV2.maritalStatus.dobStr.length > 0;
      isValid = isValid && (this.clientModelV2.maritalStatus.gender == 1 || this.clientModelV2.maritalStatus.gender == 2);

      isValid = isValid && this.clientModelV2.maritalStatus.retirementAge > 0;
      isValid = isValid && this.clientModelV2.maritalStatus.retirementState != '' && this.clientModelV2.maritalStatus.retirementState.length > 1;
      

    } else if (this.clientModelV2.maritalStatus && this.clientModelV2.maritalStatus.maritalStatus === 'Divorced') {
      if (this.clientModelV2.maritalStatus.dob === undefined) {
  
      } else {
        isValid = isValid && this.clientModelV2.maritalStatus.dobStr && this.clientModelV2.maritalStatus.dobStr.length > 0;
        this.validateDefaultDate2 = isValid && this.validateDate(this.clientModelV2.maritalStatus.dobStr, true);
      }

      if (this.clientModelV2.maritalHistory.alive) {
        isValid = isValid && this.clientModelV2.maritalStatus.firstName != "";
        isValid = isValid && this.clientModelV2.maritalStatus.lastName != "";
        isValid = isValid && this.clientModelV2.maritalStatus.dobStr && this.clientModelV2.maritalStatus.dobStr.length > 0;
        isValid = isValid && (this.clientModelV2.maritalStatus.gender == 1 || this.clientModelV2.maritalStatus.gender == 2);

        if (this.clientModelV2.maritalHistory.tenyears) {       
          isValid = isValid && this.clientModelV2.maritalStatus.retirementAge > 0;
          isValid = isValid && this.clientModelV2.maritalStatus.retirementState != '' && this.clientModelV2.maritalStatus.retirementState.length > 1;
        }
      }

     isValid = isValid && (this.clientModelV2.maritalHistory.alive == true || this.clientModelV2.maritalHistory.alive == false);


      if (this.clientModelV2.maritalHistory.alive)
        isValid = isValid && (this.clientModelV2.maritalHistory.tenyears == true || this.clientModelV2.maritalHistory.tenyears == false);

      if (!this.clientModelV2.maritalHistory.alive) {
        isValid = isValid && this.clientModelV2.maritalStatus.dobStr && this.clientModelV2.maritalStatus.dobStr.length > 0;
        
      }

    } else if (this.clientModelV2.maritalStatus && this.clientModelV2.maritalStatus.maritalStatus === 'Widow') {
      isValid = isValid && this.clientModelV2.maritalStatus.firstName != "";
      isValid = isValid && this.clientModelV2.maritalStatus.lastName != "";
    }
  }

  

}
      
      isValid = isValid && this.clientModelV2.generalInformation.retirementAge > 30;
      isValid = isValid && this.clientModelV2.generalInformation.retirementState.length > 0;
     


    } 
    
    //PAGE 1

    else if (page === 1) {
      isValid = isValid && this.clientModelV2.financialInformation.currentIncome != "" && this.clientModelV2.financialInformation.currentIncome.length > 1;
      isValid = isValid && this.clientModelV2.financialInformation.irr != "" && this.clientModelV2.financialInformation.irr.length > 0;
      isValid = isValid && this.clientModelV2.financialInformation.pia != "" && this.clientModelV2.financialInformation.pia.length > 1;
      
      isValid = this.clientModelV2.generalInformation.dob;
      
      

      if (this.clientModelV2.financialInformation.PIAYears.IncludePIA) {
        isValid = isValid && Number(this.clientModelV2.financialInformation.PIAYears.StartYear) > 1900;
        isValid = isValid && Number(this.clientModelV2.financialInformation.PIAYears.EndYear) > 1900;
        isValid = isValid && this.clientModelV2.financialInformation.PIAYears.Years.length > 0;
      }

      if (this.clientModelV2.financialInformation.hasPension) {
        isValid = isValid && this.clientModelV2.financialInformation.pensionAmount.length > 1;
        isValid = isValid && this.clientModelV2.financialInformation.pensionStartMonth > 0;
        isValid = isValid && this.clientModelV2.financialInformation.pensionStartYear > 0;
        isValid = isValid && this.clientModelV2.financialInformation.pensionSubEarnings > 0;
      }


      if (page === 1) {
        isValid = isValid && this.clientModelV2.healthInformation && this.clientModelV2.healthInformation.lifeExpectancy && this.clientModelV2.healthInformation.lifeExpectancy > 0;
      
        if (isValid) {
          if (this.clientModelV2.maritalStatus && this.clientModelV2.maritalStatus.maritalStatus === 'Single') {
            isValid = true;
          } else if (this.clientModelV2.maritalStatus && this.clientModelV2.maritalStatus.maritalStatus === 'Married') {
      
            if (this.clientModelV2.maritalStatus.dob === undefined) {
              this.validateDefaultDate = true;
      
            } else {
              isValid = isValid && this.clientModelV2.maritalStatus.dobStr && this.clientModelV2.maritalStatus.dobStr.length > 0;
              this.validateDefaultDate2 = isValid && this.validateDate(this.clientModelV2.maritalStatus.dobStr, true);
            }
            
            isValid = isValid && this.clientModelV2.maritalStatus && this.clientModelV2.maritalStatus.lifeExpectancy && this.clientModelV2.maritalStatus.lifeExpectancy > 0;
            isValid = isValid && this.clientModelV2.maritalStatus.currentIncome != "" && this.clientModelV2.maritalStatus.currentIncome.length > 1;
            isValid = isValid && this.clientModelV2.maritalStatus.pia.length > 1;
      
            if (this.clientModelV2.maritalStatus.PIAYears.includePIA === true) {
              isValid = isValid && Number(this.clientModelV2.maritalStatus.PIAYears.startYear) > 1900;
              isValid = isValid && Number(this.clientModelV2.maritalStatus.PIAYears.endYear) > 1900;
              isValid = isValid && this.clientModelV2.maritalStatus.PIAYears.years.length > 0;
            }
      
            if (this.clientModelV2.maritalStatus.includePension === true) {
              isValid = isValid && this.clientModelV2.maritalStatus.pensionAmount && this.clientModelV2.maritalStatus.pensionAmount.length > 1;
              isValid = isValid && this.clientModelV2.maritalStatus.pensionMonths > 0;
              isValid = isValid && this.clientModelV2.maritalStatus.pensionYears > 0;
              isValid = isValid && this.clientModelV2.maritalStatus.subEarnings > 0;
            }
                     
      
          } else if (this.clientModelV2.maritalStatus && this.clientModelV2.maritalStatus.maritalStatus === 'Divorced') {
            if (this.clientModelV2.maritalStatus.dob === undefined) {
        
            } else {
              isValid = isValid && this.clientModelV2.maritalStatus.dobStr && this.clientModelV2.maritalStatus.dobStr.length > 0;
              this.validateDefaultDate2 = isValid && this.validateDate(this.clientModelV2.maritalStatus.dobStr, true);
            }
      
            if (this.clientModelV2.maritalHistory.alive) {
              isValid = isValid && this.clientModelV2.maritalStatus.firstName != "";
              isValid = isValid && this.clientModelV2.maritalStatus.lastName != "";
              isValid = isValid && this.clientModelV2.maritalStatus.dobStr && this.clientModelV2.maritalStatus.dobStr.length > 0;
              isValid = isValid && (this.clientModelV2.maritalStatus.gender == 1 || this.clientModelV2.maritalStatus.gender == 2);
      
              if (this.clientModelV2.maritalHistory.tenyears) {
                isValid = isValid && this.clientModelV2.maritalStatus.pia != "";
                // isValid = isValid && this.clientModelV2.maritalStatus.retirementAge > 0;
                // isValid = isValid && this.clientModelV2.maritalStatus.retirementState != '' && this.clientModelV2.maritalStatus.retirementState.length > 1;
              }
            }
      
           isValid = isValid && (this.clientModelV2.maritalHistory.alive == true || this.clientModelV2.maritalHistory.alive == false);
      
      
            if (this.clientModelV2.maritalHistory.alive)
              isValid = isValid && (this.clientModelV2.maritalHistory.tenyears == true || this.clientModelV2.maritalHistory.tenyears == false);
      
            if (!this.clientModelV2.maritalHistory.alive) {
              //isValid = isValid && this.clientModelV2.maritalStatus.dobStr && this.clientModelV2.maritalStatus.dobStr.length > 0;
              isValid = isValid && this.clientModelV2.maritalStatus.pia != "";
            }
      
          } else if (this.clientModelV2.maritalStatus && this.clientModelV2.maritalStatus.maritalStatus === 'Widow') {
            // isValid = isValid && this.clientModelV2.maritalStatus.firstName != "";
            // isValid = isValid && this.clientModelV2.maritalStatus.lastName != "";
            isValid = isValid && this.clientModelV2.maritalStatus.pia != "";
          }
        }
      
      }



    } 
    
    //PAGE 2
    else if (page === 2) {
      isValid = isValid && this.clientModelV2.healthInformation && this.clientModelV2.healthInformation.lifeExpectancy && this.clientModelV2.healthInformation.lifeExpectancy > 0;
    } 
        
    //PAGE 3 REFACTORED//         
    
    else if (page === 4) {
      isValid = isValid && this.clientModelV2.healthInformation && this.clientModelV2.healthInformation.lifeExpectancy && this.clientModelV2.healthInformation.lifeExpectancy > 0;

      if (isValid) {
        if (!this.clientModelV2.maritalHistory.previouslyMarried && !this.clientModelV2.maritalHistory.spousePreviouslyMarried) {
          isValid = true;
        } else {
          if (this.clientModelV2.maritalHistory.previouslyMarried) {
            isValid = isValid && this.clientModelV2.maritalHistory.previousSpouseCount > 0;

            for (var spouse in this.clientModelV2.spouses) {
              if (Number(spouse) != 0) {
                isValid = isValid && this.clientModelV2.spouses[spouse].firstName.length > 0;
                isValid = isValid && this.clientModelV2.spouses[spouse].lastName.length > 0;
                isValid = isValid && this.clientModelV2.spouses[spouse].pia.length >= 0;

                if (this.clientModelV2.spouses[spouse].maritalStatus === 'Divorced') {
                  isValid = isValid && this.clientModelV2.spouses[spouse].gender == 1 || isValid && this.clientModelV2.spouses[spouse].gender == 2;
                  isValid = isValid && this.clientModelV2.spouses[spouse].dobStr && this.clientModelV2.spouses[spouse].dobStr.length > 0;
                }
              }
            }
          }

          if (this.clientModelV2.maritalHistory.spousePreviouslyMarried) {
            isValid = isValid && this.clientModelV2.maritalHistory.spousesSpouseCount > 0;
            // //console.log('inside');
            // //console.log(this.clientModelV2.maritalHistory.spousesSpouse);
            for (var spouse in this.clientModelV2.maritalHistory.spousesSpouse) {
              isValid = isValid && this.clientModelV2.maritalHistory.spousesSpouse[spouse].firstName.length > 0;
              isValid = isValid && this.clientModelV2.maritalHistory.spousesSpouse[spouse].lastName.length > 0;
              isValid = isValid && this.clientModelV2.maritalHistory.spousesSpouse[spouse].pia.length > 0;
              // //console.log('inside a');
              // //console.log(this.clientModelV2.maritalHistory.spousesSpouse[spouse]);
              if (this.clientModelV2.maritalHistory.spousesSpouse[spouse].maritalStatus === 'Divorced') {
                isValid = isValid && this.clientModelV2.maritalHistory.spousesSpouse[spouse].gender == 1 || isValid && this.clientModelV2.maritalHistory.spousesSpouse[spouse].gender == 2;
                isValid = isValid && this.clientModelV2.maritalHistory.spousesSpouse[spouse].dobStr.length > 0;
              }
            }
          }
        }
      }
      // isValid = isValid && this.clientModelV2.spouses[0] && this.clientModelV2.spouses[0].firstName != "";
    } else if (page === 5) {
      isValid = isValid && this.clientModelV2.healthInformation && this.clientModelV2.healthInformation.lifeExpectancy && this.clientModelV2.healthInformation.lifeExpectancy > 0;

      if (isValid) {
        if (this.clientModelV2.dependentChildren.hasKids) {
          for (var child in this.clientModelV2.dependentChildren.children) {
            isValid = isValid && this.clientModelV2.dependentChildren.children[child].DependentChildAge > 0;
          }
        } else {
          isValid = true;
        }
      }
    }

    if (page >= 0)
      this.validFormInputs[page].isValid = isValid;
  }

  ValidateInputScreen(page) {
    if (page === 0) {

    }
  }

  mapToSpouses(model) {
    // //console.log('cool');
  }

  updateSpouses(model) {
    if (model.maritalStatus.maritalStatus == 'Single' || model.maritalStatus.maritalStatus == 'Married' || model.maritalStatus.maritalStatus == 'Divorced' || model.maritalStatus.maritalStatus == 'Widow') {

    }

    if (model.spouses.length - 1 < this.clientModelV2.maritalHistory.previousSpouseCount) {
      for (var i = 0; i <= this.clientModelV2.maritalHistory.previousSpouseCount; i++) {
        if (model.spouses[i] && model.spouses[i].maritalStatus) {

        } else {
          this.clientModelV2.spouses.push({
            maritalStatus: '',
            firstName: '',
            lastName: '',
            pia: 0,
            gender: 0,
            dobStr: '',
          });
        }
      }
    }

    // for (var i = 0; i <= this.clientModelV2.maritalHistory.previousSpouseCount; i++) {
    //   if (i = 0) {
    //     model.spouses.push(this.clientModelV2.spouses[i]);
    //   } else if (this.clientModelV2.spouses[i] && (this.clientModelV2.spouses[i].maritalStatus == 'Widowed' || this.clientModelV2.spouses[i].maritalStatus == 'Divorced')) {
    //     model.spouses.push(this.clientModelV2.spouses[i]);
    //   } else {
    //     model.spouses.push({
    //       maritalStatus: ''
    //     });
    //   }
    // }
  }








  public allStates: any[] = Utils.allStates;
  public allStates2: any[] = Utils.allStates;

  public months: any[] = Utils.months;

  public categories: any = {};

  public error: string;

  public modalName: string;
  private ID: number; // ID of whatever entity we need to get data for

  public advisorOrganization: string = "This input field will allow you to create a client on behalf of, and assign it to the selected organization. PDF reports generated will show information and brand logos for the selected organization.";
  public assignAdvisor: string = "This input field will allow you to create a client on behalf of, and assign it to the selected organization. PDF reports generated will show information and brand logos for the selected advisor.";
  public currentAgeMessage: string = "Your date of birth allows us to project inflation and other factors that will occur over time, leading up to your retirement.";
  public retirementAgeMessage: string = "This is the year at which your income switches to an amount affected by your Income Replacement Ratio. This is not your Social Security Full Retirement Age or claim age, but for income calculation purposes on the Medicare Means Testing tool, this is the age when income switches from the amount earned as a worker to an amount earned in retirement.";
  public currentIncomeMessage: string = "This amount will be inflated out to retirement age and then multiplied by the income replacement ratio to determine projected retirement income. This should include income off of which the client currently maintains their standard of living, like compensation, bonuses, investment income, or rental income, for example.";
  public maritalStatusMessage: string = "This affects your Social Security claiming options, and for those currently married, all reports with run for both you and your spouse.";
  //public retirementStateMessage: string = "Retirement health care costs vary based on state of residence. Your retirement state may be different than your state of residence";
  public retirementStateMessage: string = "Retirement health care costs vary based on state of residence. Your retirement state may be different than your state of residence. Medicare Part D premiums, supplemental insurance, and out-of-pocket costs may vary depending on state.";
  public currentIRRMessage: string = "This is the percentage of pre-retirement income that the entire household (spouse included, if applicable) will need in retirement. For example, those earning $100,000 entering retirement age with an 80% IRR would need $80,000 per year to maintain their standard of living.";
  public nationalAvgMessage: string = "This should be used if the client is not sure where they might retire, even if a retirement state is selected.";
  public highBloodPressureMessage: string = 'Clients diagnosed with high blood pressure by a doctor should answer yes to this question. High blood pressure indicates high pressure (tension) in the arteries and is typically a blood pressure of 140/90 or higher. Normal blood pressure is below 120/80. Blood pressure between 120/80 and 139/89 is called "pre-hypertension".';
  public highCholesterolMessage: string = "Clients diagnosed with high cholesterol by a doctor should answer yes to this question. High levels of cholesterol in the blood is not a disease but a condition that lead to other diseases, most notably cardiovascular disease. A doctor typically considers high cholesterol a measurement greater than 200 mg/dL, LDL cholesterol levels greater than 130 mg/dL and HDL cholesterol levels less than 60 mg/dL.";
  public type2DiabetesMessage: string = "Clients diagnosed with type 2 diabetes (managed or unmanaged) by a doctor should answer yes to this question. Type 2 diabetes is a chronic condition that affects the way someone’s body metabolizes sugar (glucose); a condition characterized by high blood glucose levels caused by either a lack of insulin or the body's inability to use insulin efficiently.";
  public cardiovascularDiseaseMessage: string = "Clients diagnosed as having cardiovascular disease by a doctor should answer yes to this question. Cardiovascular disease is a disease affecting the heart or blood vessels. Some conditions that fall under the umbrella of cardiovascular disease are aneurysm, angina, arrhythmia, cardiomyopathy, congenital cardiovascular defects, congenital heart disease, congestive heart failure, heart attack, diseases of pulmonary circulation, endocarditis, rheumatic fever, stroke, heart valve disease, diseases of the circulatory system.";
  public tobaccoMessage: string = "Clients having used tobacco in any form (cigarettes, cigars, pipes etc..) on a consistent basis within the last 5 years should answer yes to this question.";
  public cancerMessage: string = "Clients should answer yes to this question if they have ever been diagnosed with any type of cancer, including breast cancer, skin cancer, lung cancer, colon cancer, prostate cancer, lymphoma, or other type of cancer.";

  public piaMessage: string = "If you don’t know your client’s PIA and want to calculate it manually, check this box and follow the instructions that appear.";
  public pensionMessage: string = "Individuals who are receiving (or are going to receive) a pension during their retirement based on working years during which they did not pay into Social Security should check this box.";
  public pensionBaseMessage: string = "The government applies provisions to Social Security regulations which may decrease or eliminate a benefit or spousal benefit given to someone who is receiving a pension.";
  public pensionStartMessage: string = "Please identify when the client will start receiving a pension. Social Security does not make deductions unless the client is currently receiving a pension. A start year is needed so as not to impose deductions in our projections that do not actually apply at that time.";
  public pensionStartMonthMessage: string = "Please identify when the client will start receiving a pension. Social Security does not make deductions unless the client is currently receiving a pension. A start month is needed so as not to impose deductions in our projections that do not actually apply at that time.";
  public pensionSubMessage: string = "Social Security measures Substantial Earnings Years by the amount of money an individual earns in a calendar year on income that is taxed by Social Security. This metric is needed to calculate deductions made to the client’s Social Security benefit by the Windfall Elimination Provision. A chart with these measures for each year can be found at http://www.ssa.gov/pubs/EN-05-10045.pdf.";

  public lifeExpectancyMessage: string = "Appropriately assessing your client’s health and longevity is a top consideration for each tool on this platform. Primary drivers of life expectancy include gender, current age, and health conditions/lifestyle. The amount defaulted in the input field is based on those variables, but you may override this result if you desire.";
  public primaryInsuranceAmountMessage: string = "Primary Insurance Amount is the monthly benefit the client will receive from Social Security at Full Retirement Age based on their earnings record. This amount is needed to project benefits throughout the client’s lifetime. This amount can be found at <a target='blank' href='https://secure.ssa.gov/RIL/SiView.do'>https://secure.ssa.gov/RIL/SiView.do</a>"
  public nationalAverageMessage: string = `Selecting "Yes" will show all projections based on national average instead of featuring the data specific to the chosen retirement state above. This selection may be made is the client is unsure of where they will spend their retirement years or if you are running a case study and looking for generic data.`;
  public previouslyMarriedMessage: string = "";

  private advisor: Advisor;
  public client: any = {};
  private organization: Organization;

  private modalData: any;

  public dobYear;

  private createClientModel: any = {
    client: {
      HCHBP: false,
      HCHC: false,
      HCT2D: false,
      HCCD: false,
      HCC: false,
      HCT: false,
    },
    clientProfile: {
      HCHBP: false,
      HCHC: false,
      HCT2D: false,
      HCCD: false,
      HCC: false,
      HCT: false,
      // LifeExpectancy: 88,
      clientSpouses: [],
      clientChildren: [],
      PIAYears: {
        IncludePIA: false,
      }
    },
  };

  private editClientModel: any = {
    loaded: false,
    client: {
      HCHBP: false,
      HCHC: false,
      HCT2D: false,
      HCCD: false,
      HCC: false,
      HCT: false,
    },
    clientProfile: {
      HCHBP: false,
      HCHC: false,
      HCT2D: false,
      HCCD: false,
      HCC: false,
      HCT: false,
      clientSpouses: [],
      clientChildren: [],
      PIAYears: {
        IncludePIA: false,
      }
    },
  };

  public modalSubscription;

  public clientDOB: IMyDate = {
    year: 1970,
    month: 1,
    day: 1,
  };

  public testDate: IMyDate = {
    year: 0,
    month: 0,
    day: 0,
  }

  public clientModelV2: any = {
    generalInformation: {
      firstName: '',
      lastName: '',
      gender: '',
      dob: '',
      address: '',
      city: '',
      state: '',
      zip: '',
      phone: '',
      email: '',
      retirementAge: '',
      retirementState: '',
    },
    financialInformation: {
      currentIncome: '',
      irr: '',
      pia: '',
      PIAYears: {},
      pensionAmount: 0,
      pensionStartMonth: '',
      pensionStartYear: '',
      pensionSubEarnings: '',
      hasPension: '',
    },
    healthInformation: {
      HCC: false,
      HCCD: false,
      HCHBP: false,
      HCHC: false,
      HCT: false,
      HCT2D: false,
      lifeExpectancy: '',
    },
    maritalStatus: {
      maritalStatus: 'Single',
      firstName: '',
      lastName: '',
      gender: '',
      lifeExpectancy: '',
      currentIncome: '',
      pia: '',
      PIAYears: {
        includePIA: '',
        startYear: '',
        endYear: '',
        years: [],
      },
    },
    spouses: [
      { maritalStatus: 'Single' }
    ],
    maritalHistory: {
      previousSpouseCount: 0,
      previouslyMarried: false,
    },
    dependentChildren: {
      children: [],
      hasKids: false,
    }
  }

  d: Date = new Date();
  defaultDOB = { date: { year: this.d.getFullYear() - 55, month: this.d.getMonth() + 1, day: this.d.getDate() } };
  defaultDOBStr = ((this.d.getMonth() + 1 <= 9) ? "0" + (this.d.getMonth() + 1) : (this.d.getMonth() + 1)) + "/" + ((this.d.getDate() <= 9) ? "0" + this.d.getDate() : this.d.getDate()) + "/" + (this.d.getFullYear() - 55);
 
  
  constructor(private modalService: ModalService, private globalService: GlobalService, private snackBarService: SnackBarService, private router: Router, private sanitizer: DomSanitizer) {

    //this.selDate = {date:{year: d.getFullYear() - 18, month: d.getMonth() + 1, day: d.getDate()}};
    //var selectedDate =  {date:{year: d.getFullYear() - 18, month: d.getMonth() + 1, day: d.getDate()}};

    this.modalSubscription = modalService.modal$.subscribe(modal => {

      //console.log('name:', this.modalName);

      if (modal.modalName.indexOf('Closed') == -1) {
        //  console.log('name:', this.modalName);

        this.modalName = modal.modalName;
        this.modalData = modal.data;
        this.ID = modal.data.ID;

        this.currentAddEditClientScreen = 0;

        this.selectedAdvisor = null;
        this.selectedOrganization = null;
        this.organizations = [];
        this.selectedAdvisors = [];

        this.clientModelV2 = {
          generalInformation: {
            firstName: '',
            lastName: '',
            gender: '',
            dob: '',//this.defaultDOB, //avg user is 55yo
            address: '',
            city: '',
            state: '',
            zip: '',
            phone: '',
            email: '',
            useNationalAverage: false,
            retirementAge: '',
            retirementState: '',
          },
          financialInformation: {
            currentIncome: '',
            irr: '',
            pia: '',
            PIAYears: {},
            pensionAmount: 0,
            pensionStartMonth: '',
            pensionStartYear: '',
            pensionSubEarnings: '',
            hasPension: '',
          },
          healthInformation: {
            HCC: false,
            HCCD: false,
            HCHBP: false,
            HCHC: false,
            HCT: false,
            HCT2D: false,
            lifeExpectancy: '',
          },
          maritalStatus: {
            maritalStatus: 'Single',
            firstName: '',
            lastName: '',
            gender: '',
            lifeExpectancy: '',
            currentIncome: '',
            pia: '',
            PIAYears: {
              includePIA: '',
              startYear: '',
              endYear: '',
              years: [],
            },
          },
          spouses: [
            { maritalStatus: 'Single' }
          ],
          maritalHistory: {
            previousSpouseCount: 0,
            previouslyMarried: false,
            spousePreviouslyMarried: false,
          },
          dependentChildren: {
            children: [],
            hasKids: false,
          }
        }

        this.validFormInputs = [
          { isValid: false },
          { isValid: false },
          { isValid: false },
          { isValid: false },
          { isValid: false },
          { isValid: false },
        ]

        this.createClientModel = {
          client: {
            // firstName: ' ',

          },
          clientProfile: {
            HCHBP: false,
            HCHC: false,
            HCT2D: false,
            HCCD: false,
            HCC: false,
            HCT: false,
            // LifeExpectancy: 88,
            clientSpouses: [],
            clientChildren: [],
            PIAYears: {
              IncludePIA: false,
            }
          },
        };

        this.editClientModel = {
          loaded: false,
          client: {

          },
          clientProfile: {
            HCHBP: false,
            HCHC: false,
            HCT2D: false,
            HCCD: false,
            HCC: false,
            HCT: false,
            clientSpouses: [],
            clientChildren: [],
            PIAYears: {
              IncludePIA: false,
            }
          },
        };

        if (this.modalName === 'close-now') {
          return this.close();
        }

        this.getData();
        this.open();
      }
    })
  }

  ngOnDestroy() {
    this.modalSubscription.unsubscribe();
  }

  onDateChanged(e, model, validationIndex) {
    // model.dobStr = e.formatted;


    if (validationIndex === 0) {
      this.clientModelV2.generalInformation.dobStr = e.formatted;
      ////console.log('inside the date change:', this.clientModelV2.generalInformation.dobStr);
      this.recalcLEV2(this.clientModelV2, 0)
    } else if (validationIndex === 3) {
      this.clientModelV2.maritalStatus.dobStr = e.formatted;
      this.recalcLEV2(this.clientModelV2, 3)
    } else if (4) {
      model.dobStr = e.formatted;
    }

    this.validateFields(validationIndex);
  }

  onAnnDateChanged(e, model, validationIndex) {
    model.anniversaryStr = e.formatted;
    this.validateFields(validationIndex);
  }

  canContinue(i, isButton) {
    if (this.isSelectingAdvisor && this.selectedAdvisor && this.selectedOrganization)
      return true;

    // //console.log('step:', i);
    return isButton ? this.validFormInputs[i].isValid : this.validFormInputs[i - 1] && this.validFormInputs[i - 1].isValid;//&& i < 5;
  }

  uploadAndSave() {
    if (this.modalData.Data.section === 'marketing-material') {
      this.uploadAndSaveMM();
    } else if (this.modalData.Data.section === 'info-center') {
      this.uploadAndSaveIC();
    }
  }

  uploadAndSaveMM() {
    let file;

    if (this.selectedDocEvent && this.selectedDocEvent.target) {
      file = this.selectedDocEvent.target.files[0];
      let formData: FormData = new FormData();
      var date = new Date().getTime() / 1000;

      formData.append('uploadFile', file, this.advisor.OrganizationID + '_' + date + '_doc' + file.name.substring(file.name.lastIndexOf('.'), file.name.length));
      formData.append('Email', this.advisor.Email);
      formData.append('UserID', this.advisor.ID.toString());
      formData.append('Category', 'marketing-material');

      this.selectedDocument.section = "marketing-material";

      let idx = 0;

      for (var key in this.modalData.Data.arr) {
        if (this.modalData.Data.arr[key].category === this.selectedDocument.category)
          idx = Number(key);
      }

      this.globalService.UploadOrgDoc(formData)
        .subscribe(
          resp => {
            this.selectedDocument.url = "https://hvswebuat1.hvsfinancial.com/portal/shared/" + resp._body;

            var item = {
              Category: this.selectedDocument.category,
              Description: this.selectedDocument.description,
              Section: this.selectedDocument.section,
              Title: this.selectedDocument.title,
              Url: this.selectedDocument.url
            }
            this.modalData.Data.arr[idx].items.push(item);
            let arr = Utils.convertMarketingMaterialOrInfoCenterToOldFormat(this.modalData.Data.arr);

            this.globalService.ReplaceMarketingMaterial(arr).subscribe(
              resp => {
                if (resp) {
                  this.selectedDocument = {
                    category: '',
                    description: '',
                    section: '',
                    title: '',
                    url: '',
                  }

                  this.selectedDocEvent.target.value = '';

                  this.close();
                  this.snackBarService.add('Document has been added', 0);
                } else {
                  this.snackBarService.add('An error occurred - please contact support', 1);
                }
              },
              error => this.error = <any>error);
          },
          error => this.error = <any>error);
    }
  }

  uploadAndSaveIC() {
    let file;

    if (this.selectedDocEvent && this.selectedDocEvent.target) {
      file = this.selectedDocEvent.target.files[0];
      let formData: FormData = new FormData();
      var date = new Date().getTime() / 1000;

      formData.append('uploadFile', file, this.advisor.OrganizationID + '_' + date + '_doc' + file.name.substring(file.name.lastIndexOf('.'), file.name.length));
      formData.append('Email', this.advisor.Email);
      formData.append('UserID', this.advisor.ID.toString());
      formData.append('Category', 'info-center');

      this.selectedDocument.section = "info-center";

      let idx = 0;

      for (var key in this.modalData.Data.arr) {
        if (this.modalData.Data.arr[key].category === this.selectedDocument.category)
          idx = Number(key);
      }

      this.globalService.UploadOrgDoc(formData)
        .subscribe(
          resp => {
            this.selectedDocument.url = "https://hvswebuat1.hvsfinancial.com/portal/shared/" + resp._body;

            var item = {
              Category: this.selectedDocument.category,
              Description: this.selectedDocument.description,
              Section: this.selectedDocument.section,
              Title: this.selectedDocument.title,
              Url: this.selectedDocument.url
            }
            this.modalData.Data.arr[idx].items.push(item);
            let arr = Utils.convertMarketingMaterialOrInfoCenterToOldFormat(this.modalData.Data.arr);

            this.globalService.ReplaceInfoCenter(arr).subscribe(
              resp => {
                if (resp) {
                  this.selectedDocument = {
                    category: '',
                    description: '',
                    section: '',
                    title: '',
                    url: '',
                  }

                  this.selectedDocEvent.target.value = '';

                  this.close();

                  this.snackBarService.add('Document has been added', 0);
                } else {
                  this.snackBarService.add('An error occurred - please contact support', 1);
                }
              },
              error => this.error = <any>error);
          },
          error => this.error = <any>error);
    }
  }

  canSave() {
    return this.validFormInputs[0].isValid &&
      this.validFormInputs[1].isValid &&
      this.validFormInputs[2].isValid &&
      this.validFormInputs[3].isValid &&
      this.validFormInputs[4].isValid &&
      this.validFormInputs[5].isValid;
  }

  ngOnInit(): void {

    this.validateAge();
    // this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;

    // //console.log('asd');

    this.createClientModel = {
      client: {
        // firstName: ' ',

      },
      clientProfile: {
        HCHBP: false,
        HCHC: false,
        HCT2D: false,
        HCCD: false,
        HCC: false,
        HCT: false,
        clientSpouses: [
        ],
        clientChildren: [],
        PIAYears: {
          IncludePIA: false,
        }
      },
    };

    this.editClientModel = {
      loaded: false,
      client: {

      },
      clientProfile: {
        HCHBP: false,
        HCHC: false,
        HCT2D: false,
        HCCD: false,
        HCC: false,
        HCT: false,
        clientSpouses: [
        ],
        clientChildren: [],
        PIAYears: {
          IncludePIA: false,
        }
      },
    };
  }

  piaStartYearWarning(dob, model, client) {
    // var year = dob.substring(dob.length - 4, dob.length);
    // //console.log(dob, year);

    // //console.log(dob, model, client);
    // //console.log(model.clientProfile.PIAYears.StartYear);
    // if (client) {
    //   if (model.clientProfile.PIAYears && model.clientProfile.PIAYears.StartYear >= year + 12 && model.clientProfile.PIAYears.EndYear >= year + 70) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // } else {
    //   if (model.clientProfile.PIAYears && model.clientProfile.PIAYears.StartYear >= year + 12 && model.clientProfile.PIAYears.EndYear >= year + 70) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // }

    // if (dob + 70 < year && dob + 12 < year) {
    //   return true;
    // } else {
    //   return false;
    // }


  }

  validateAllFields() {
    this.validateFields(0);
    this.validateFields(1);
    this.validateFields(2);
    this.validateFields(3);
    this.validateFields(4);
    this.validateFields(5);
  }

  piaEndYearWarning(dob, model, client) {
    // //console.log(dob.substring(dob.length - 4, dob.length));
  }

  setActiveErrorPage() {
    var page = 0;
    for (var i = 0; i < this.validFormInputs.length; i++) {
      if (!this.validFormInputs[i].isValid && page === 0) {
        page = i;
      }
    }

    this.currentAddEditClientScreen = page;
  }

  public organizations: any;
  public advisors: any;

  public selectedOrganization: any;
  public selectedAdvisors: any;
  public selectedAdvisor: any;

  handleOrgSelected(auto) {
    this.selectedAdvisors = [];
    var temp = [];

    temp = this.advisors.sort((a, b) => {
      if (a.c.FirstName.toLowerCase() < b.c.FirstName.toLowerCase()) return -1;
      if (a.c.FirstName.toLowerCase() > b.c.FirstName.toLowerCase()) return 1;
      return 0;
    });

    temp.forEach((advisor) => {
      if (advisor.o.ID == this.selectedOrganization) {
        if (advisor.c.FirstName.length > 0 && advisor.c.LastName.length > 0) {
          if (advisor.c.IsActive) {
            this.selectedAdvisors.push(advisor);
          }
        }
      }
    });

    if (auto) {
      this.selectedAdvisor = this.advisor.ID;
    } else {
      this.selectedAdvisor = 0;
    }
  }

  public isSelectingAdvisor: boolean = false;

  getData(): void {

    if (this.modalName === 'edit-advisor') {
      this.globalService.getAdvisorData(this.ID)
        .subscribe(
          advisor => {
            this.advisor = advisor;
          },
          error => this.error = <any>error);
    } else if (this.modalName === 'add-edit-client') {

      // //console.log(this.modalData);
      if (this.modalData.ID > 0) {
        this.isSelectingAdvisor = false;
        this.updateAddEditClientScreen(1);
      } else if ((Number(localStorage.getItem('roleId')) == 1 || Number(localStorage.getItem('roleId')) == 2) && !this.modalData.Advisor) {
        this.isSelectingAdvisor = true;
      }

      // //console.log(this.modalData);

      ////console.log(JSON.stringify(this.modalData));

      if (this.modalData.Advisor) {
        this.selectedAdvisor = {};
        this.selectedAdvisor.c = this.modalData.Advisor;
        this.selectedAdvisor.o = this.modalData.Advisor.OrganizationID;
        this.selectedOrganization = this.modalData.Advisor.OrganizationID;
      }

      this.globalService.getAdvisorData(Number(localStorage.getItem('userId')))
        .subscribe(
          advisor => {
            this.advisor = advisor;

            if (Number(localStorage.getItem('roleId')) == 1 || Number(localStorage.getItem('roleId')) == 2) {
              this.globalService.getOrganizationsData()
                .subscribe(
                  organizations => {
                    var temp = [];

                    organizations.forEach((org) => {
                      if (org.Name.length > 0) {
                        org.Name = org.Name.toLowerCase().replace(/\b\w/g, l => l.toUpperCase());
                        temp.push(org);
                      }
                    });

                    temp = temp.sort((a, b) => {
                      if (a.Name.toLowerCase() < b.Name.toLowerCase()) return -1;
                      if (a.Name.toLowerCase() > b.Name.toLowerCase()) return 1;
                      return 0;
                    });

                    this.organizations = temp;
                  },
                  error => this.error = <any>error);

              this.globalService.getAdvisorsData(1)
                .subscribe(
                  advisors => {
                    this.advisors = advisors;

                    if (this.isSelectingAdvisor) {
                      this.selectedOrganization = advisor.OrganizationID;
                      this.handleOrgSelected(true);
                    }
                  },
                  error => this.error = <any>error);
            }
          },
          error => this.error = <any>error);

      this.globalService.getClientData(this.ID, 4)
        .subscribe(
          client => {
            // //console.log(client);
            this.client = client;
            this.mapToClientObject(client);

            this.validateAllFields();
            if (client.clientProfile)
              this.setActiveErrorPage();
          },
          error => this.error = <any>error);

    }
    // else if (this.modalName === 'add-edit-client') {
    //   // this.client = {};

    //   this.globalService.getClientData(this.ID, 4)
    //     .subscribe(
    //     client => { 
    //       this.client = client; 

    //       if (client.clientProfile.Children) {
    //         this.client.clientProfile.Children = JSON.parse(this.client.clientProfile.Children);
    //       } else
    //         this.client.clientProfile.Children = [];

    //       if (client.clientProfile.Spouses) {
    //         this.client.clientProfile.Spouses = JSON.parse(this.client.clientProfile.Spouses);

    //         for (var spouse in client.clientProfile.Spouses) {
    //           //console.log(client.clientProfile.Spouses[spouse]);

    //           if (client.clientProfile.Spouses[spouse].maritalStatus == "Married") {
    //             if (!client.clientProfile.Spouses[spouse].LifeExpectancy) {
    //               // client.clientProfile.Spouses[spouse].LifeExpectancy = 88;
    //             } else {

    //             }
    //           }

    //           // if (!client.clientProfile.LifeExpectancy) {  
    //           //   var LEObject = {
    //           //     gender: this.client.client.GenderID,
    //           //     age: this.calculateAge(this.client.client.DOB),
    //           //     healthConditions: {
    //           //       HCC: this.client.clientProfile.HCC,
    //           //       HCCD: this.client.clientProfile.HCCD,
    //           //       HCHBP: this.client.clientProfile.HCHBP,
    //           //       HCHC: this.client.clientProfile.HCHC,
    //           //       HCT: this.client.clientProfile.HCT,
    //           //       HCT2D: this.client.clientProfile.HCT2D,
    //           //     },
    //           //   }

    //           //   this.globalService.getLE(LEObject)
    //           //     .subscribe(
    //           //     le => { this.editClientModel.clientProfile.LifeExpectancy = le },
    //           //     error => this.error = <any>error);
    //           // }
    //         }

    //       } else
    //         this.client.clientProfile.Spouses = [];

    //       this.editClientModel = this.client;
    //       this.editClientModel.loaded = true;

    //       //console.log(client);

    //       if (!client.clientProfile.LifeExpectancy) {  
    //         var LEObject = {
    //           gender: this.client.client.GenderID,
    //           age: this.calculateAge(this.client.client.DOB),
    //           healthConditions: {
    //             HCC: this.client.clientProfile.HCC,
    //             HCCD: this.client.clientProfile.HCCD,
    //             HCHBP: this.client.clientProfile.HCHBP,
    //             HCHC: this.client.clientProfile.HCHC,
    //             HCT: this.client.clientProfile.HCT,
    //             HCT2D: this.client.clientProfile.HCT2D,
    //           },
    //         }

    //         this.globalService.getLE(LEObject)
    //           .subscribe(
    //           le => { this.editClientModel.clientProfile.LifeExpectancy = le },
    //           error => this.error = <any>error);
    //       }

    //       if (this.editClientModel.clientProfile.PIAYears) {
    //         this.editClientModel.clientProfile.PIAYears = JSON.parse(this.editClientModel.clientProfile.PIAYears);
    //       } else {
    //         this.editClientModel.clientProfile.PIAYears = {};
    //         this.editClientModel.clientProfile.PIAYears.IncludePIA = null;
    //       }



    //       this.formatEditClientModel();

    //       //console.log(this.client);

    //     },
    //     error => this.error = <any>error);
    //} 
    else if (this.modalName === 'edit-organization') {
      this.globalService.getOrganizationData(this.ID)
        .subscribe(
          organization => { this.organization = organization; },
          error => this.error = <any>error);
    } else if (this.modalName === 'view-lead') {
      // //console.log('view lead modal active');
      // //console.log(this.modalData);
      //
    } else if (this.modalName === 'assign-lead') {
      // //console.log('assign lead modal active');
      // //console.log(this.modalData);
      //
    } else if (this.modalName === 'edit-profile') {
      this.globalService.getAdvisorData(this.ID)
        .subscribe(
          advisor => {
            this.advisor = advisor;

            this.advisorTemp = {
              FirstName: this.advisor.FirstName,
              LastName: this.advisor.LastName,
              Phone: this.advisor.Phone,
            }
          },
          error => this.error = <any>error);
    }
    // else if (this.modalName === 'add-edit-client') {
    // this.globalService.getAdvisorData(Number(localStorage.getItem('userId')))
    //   .subscribe(
    //   advisor => {
    //     this.advisor = advisor;
    //   },
    //   error => this.error = <any>error);
    // }
    else if (this.modalName === 'upload-doc') {
      this.categories = this.modalData.Data.categories;
      this.globalService.getAdvisorData(this.ID)
        .subscribe(
          advisor => {
            this.advisor = advisor;

          },
          error => this.error = <any>error);
    }
    else if (this.modalName === 'mmt-projections') {

    } else if (this.modalName === 'contact-support') {
      this.globalService.getAdvisorData(Number(localStorage.getItem('userId')))
        .subscribe(
          advisor => {
            this.advisor = advisor;
          },
          error => this.error = <any>error);
    } else if (this.modalName === 'hc-projections') {
      // var totalBeginningValue = 0;
      // var totalContribution = 0;
      // var totalHealthCareExpense = 0;
      // var totalEndingValue = 0;

      for (var item in this.modalData.Data) {
        // //console.log(this.modalData.Data[item]);
        // totalBeginningValue = totalBeginningValue + Number(this.modalData.Data[item].BeginningBalance.replace('$', '').replace(',',''));
        // totalContribution = totalContribution + Number(this.modalData.Data[item].Contribution.replace('$', '').replace(',',''));
        // totalHealthCareExpense = totalHealthCareExpense + Number(this.modalData.Data[item].Total.replace('$', '').replace(',',''));
        // totalEndingValue = totalEndingValue + ( this.modalData.Data[item].EndingBalance ? Number(this.modalData.Data[item].EndingBalance.replace('$', '').replace(',','')) : 0);

        for (var key in this.modalData.Data[item]) {
          if (key !== 'ExpectedRateReturn' && key !== 'Year') {
            this.modalData.Data[item][key] = this.modalData.Data[item][key];
          } else if (key == 'ExpectedRateReturn') {
            this.modalData.Data[item][key] = Number.parseFloat(this.modalData.Data[item][key]).toFixed(2) + '%';
          }
        }
      }

      // this.hcProjectionTotal.totalBeginningValue = Utils.formatToCurrency(totalBeginningValue);
      // this.hcProjectionTotal.totalContribution = Utils.formatToCurrency(totalContribution);
      // this.hcProjectionTotal.totalHealthCareExpense = Utils.formatToCurrency(totalHealthCareExpense);
      // this.hcProjectionTotal.totalEndingValue = Utils.formatToCurrency(totalEndingValue);
    } else if (this.modalName === 'ltc-projections') {
      // //console.log(this.modalData);
    }

  }

  public hcProjectionTotal: any = {};

  handleProducerClientCreation() {

  } 
 
  mapToClientObject(client) {
    if (client.client && client.client.FirstName) {

      // General Information
      this.clientModelV2.generalInformation.firstName = client.client.FirstName;
      this.clientModelV2.generalInformation.lastName = client.client.LastName;
      this.clientModelV2.generalInformation.gender = client.client.GenderID;
      this.clientModelV2.generalInformation.dob = {
        date: {
          year: new Date(client.client.DOB).getFullYear(),
          month: new Date(client.client.DOB).getMonth() + 1,
          day: new Date(client.client.DOB).getDate()
        }
      };

      this.currentYear = new Date().getFullYear();
      this.dateofBirth = new Date(client.client.DOB).getFullYear();
      this.yob = this.dateofBirth + 14;
      this.endOfPIAStartYear = this.currentYear - this.yob + 1;      
      this.endYear1 = this.dateofBirth + 30;
      this.endYear2 = this.dateofBirth + 80;               
      this.endOfPIAEndYear = this.endYear2 - this.endYear1 + 1;   

      this.clientModelV2.generalInformation.dobStr = client.client.DOB;    

      if (this.clientModelV2.generalInformation.dobStr) {
        const convertAge = new Date(this.clientModelV2.generalInformation.dobStr);
        const timeDiff = Math.abs(Date.now() - convertAge.getTime());
        this.showAge = Math.floor((timeDiff / (1000 * 3600 * 24))/365); 
        //console.log("Age",this.showAge);
       }  

      this.clientModelV2.generalInformation.address = client.client.Address;
      this.clientModelV2.generalInformation.city = client.client.City;
      this.clientModelV2.generalInformation.state = client.client.State;
      this.clientModelV2.generalInformation.zip = client.client.Zip;
      this.clientModelV2.generalInformation.phone = client.client.Phone;
      this.clientModelV2.generalInformation.email = client.client.Email;
      this.clientModelV2.generalInformation.useNationalAverage = client.clientProfile.UseNationalAverage || 0; // BP -> Add national average flag
      this.clientModelV2.generalInformation.retirementAge = client.clientProfile.RetirementAge;
      this.clientModelV2.generalInformation.retirementState = client.clientProfile.RetirementState;
      // //console.log(this.clientModelV2);
      // Financial Information
      this.clientModelV2.financialInformation.currentIncome = this.formatCurrencyV2(client.clientProfile.CurrentIncome);
      this.clientModelV2.financialInformation.irr = client.clientProfile.IRR + '%';
      this.clientModelV2.financialInformation.pia = this.formatCurrencyV2(client.clientProfile.PIA || 0);
      this.clientModelV2.financialInformation.PIAYears = JSON.parse(client.clientProfile.PIAYears) || {};
      this.clientModelV2.financialInformation.pensionAmount = this.formatCurrencyV2(client.clientProfile.Pension);
      this.clientModelV2.financialInformation.pensionStartMonth = client.clientProfile.PensionMonths;
      this.clientModelV2.financialInformation.pensionStartYear = client.clientProfile.PensionYears;
      this.clientModelV2.financialInformation.pensionSubEarnings = client.clientProfile.SubstantialEarningYears;
      this.clientModelV2.financialInformation.hasPension = client.clientProfile.IncludePension == 1 ? true : false;

      // Health Conditions
      this.clientModelV2.healthInformation.HCC = client.clientProfile.HCC == 1 ? true : false;
      this.clientModelV2.healthInformation.HCCD = client.clientProfile.HCCD == 1 ? true : false;
      this.clientModelV2.healthInformation.HCHBP = client.clientProfile.HCHBP == 1 ? true : false;
      this.clientModelV2.healthInformation.HCHC = client.clientProfile.HCHC == 1 ? true : false;
      this.clientModelV2.healthInformation.HCT = client.clientProfile.HCT == 1 ? true : false;
      this.clientModelV2.healthInformation.HCT2D = client.clientProfile.HCT2D == 1 ? true : false;
      this.clientModelV2.healthInformation.lifeExpectancy = client.clientProfile.LifeExpectancy;
     
      this.min = Math.min(this.clientModelV2.healthInformation.lifeExpectancy, this.showAge);      
      this.minAge = this.min
      this.maxAge = 100 - this.minAge + 1;    

      this.clientModelV2.spouses = JSON.parse(client.clientProfile.Spouses);

      if (this.clientModelV2.spouses[0] && this.clientModelV2.spouses[0].maritalStatus != "Single") {
        // Marital Status
        this.clientModelV2.maritalStatus.maritalStatus = typeof this.clientModelV2.spouses[0].maritalStatus === 'undefined' || typeof this.clientModelV2.spouses[0] === 'undefined' ? 'Single' : this.clientModelV2.spouses[0].maritalStatus;
        this.clientModelV2.maritalStatus.firstName = this.clientModelV2.spouses[0].firstName;
        this.clientModelV2.maritalStatus.lastName = this.clientModelV2.spouses[0].lastName;
        this.clientModelV2.maritalStatus.gender = this.clientModelV2.spouses[0].gender;
        this.clientModelV2.maritalStatus.lifeExpectancy = this.clientModelV2.spouses[0].LifeExpectancy;
        this.clientModelV2.maritalStatus.currentIncome = Utils.formatToCurrency(this.clientModelV2.spouses[0].currentIncome);
        this.clientModelV2.maritalStatus.anniversary = this.clientModelV2.spouses[0].anniversary ? {
          date: {
            year: new Date(this.clientModelV2.spouses[0].anniversary).getFullYear(),
            month: new Date(this.clientModelV2.spouses[0].anniversary).getMonth() + 1,
            day: new Date(this.clientModelV2.spouses[0].anniversary).getDate()
          }
        } : {};

      this.spouseDateofBirth = new Date(this.clientModelV2.spouses[0].anniversary).getFullYear();
     // console.log("this.spouseDateofBirth",this.spouseDateofBirth);
      this.spouseYob = this.spouseDateofBirth + 14;
      this.spouseEndOfPIAStartYear = this.currentYear - this.spouseYob + 1;      
      this.spouseEndYear1 = this.spouseDateofBirth + 30;
      this.spouseEndYear2 = this.spouseDateofBirth + 80;               
      this.spouseEndOfPIAEndYear = this.spouseEndYear1 - this.spouseEndYear2 + 1; 

        this.clientModelV2.maritalStatus.anniversaryStr = this.clientModelV2.spouses[0].anniversary;

        this.clientModelV2.maritalStatus.dob = this.clientModelV2.spouses[0].dob ? {
          date: {
            year: new Date(this.clientModelV2.spouses[0].dob).getFullYear() || 0,
            month: new Date(this.clientModelV2.spouses[0].dob).getMonth() + 1 || 0,
            day: new Date(this.clientModelV2.spouses[0].dob).getDate() || 0
          }
        } : {};

        this.clientModelV2.maritalStatus.dobStr = this.clientModelV2.spouses[0].dob;


        if (this.clientModelV2.maritalStatus.dobStr) {
          const convertAge = new Date(this.clientModelV2.maritalStatus.dobStr);
          const timeDiff = Math.abs(Date.now() - convertAge.getTime());
          this.spouseShowAge = Math.floor((timeDiff / (1000 * 3600 * 24))/365);           
         } 

         this.SpouseMin = Math.min(this.clientModelV2.maritalStatus.lifeExpectancy, this.spouseShowAge);      
         this.spouseMinAge = this.SpouseMin
         this.spouseMaxAge = 100 - this.spouseMinAge + 1;  


        this.clientModelV2.maritalStatus.pia = this.clientModelV2.spouses[0].pia ? this.formatCurrencyV2(this.clientModelV2.spouses[0].pia.replace(/,/g, '').replace('$', '')) : this.formatCurrencyV2(0);
        this.clientModelV2.maritalStatus.PIAYears = this.clientModelV2.spouses[0].PIAYears || {};
        this.clientModelV2.maritalStatus.PIAYears.includePIA = this.clientModelV2.maritalStatus.PIAYears.IncludePIA;
        this.clientModelV2.maritalStatus.PIAYears.startYear = this.clientModelV2.maritalStatus.PIAYears.StartYear;
        this.clientModelV2.maritalStatus.PIAYears.endYear = this.clientModelV2.maritalStatus.PIAYears.EndYear;
        this.clientModelV2.maritalStatus.PIAYears.years = this.clientModelV2.maritalStatus.PIAYears.Years;
        this.clientModelV2.maritalStatus.includePension = this.clientModelV2.spouses[0].includePension;
        this.clientModelV2.maritalStatus.pensionAmount = this.formatCurrencyV2(this.clientModelV2.spouses[0].pension || this.clientModelV2.spouses[0].pensionAmount || 0);
        this.clientModelV2.maritalStatus.pensionMonths = this.clientModelV2.spouses[0].pensionMonth;
        this.clientModelV2.maritalStatus.pensionYears = this.clientModelV2.spouses[0].pensionYear;
        this.clientModelV2.maritalStatus.subEarnings = this.clientModelV2.spouses[0].substantialEarningYears;
        this.clientModelV2.maritalStatus.retirementAge = this.clientModelV2.spouses[0].retirementAge;
        this.clientModelV2.maritalStatus.retirementState = this.clientModelV2.spouses[0].state;
        this.clientModelV2.maritalStatus.HCC = this.clientModelV2.spouses[0].HCC == 1 ? true : false;
        this.clientModelV2.maritalStatus.HCCD = this.clientModelV2.spouses[0].HCCD == 1 ? true : false;
        this.clientModelV2.maritalStatus.HCHBP = this.clientModelV2.spouses[0].HCHBP == 1 ? true : false;
        this.clientModelV2.maritalStatus.HCHC = this.clientModelV2.spouses[0].HCHC == 1 ? true : false;
        this.clientModelV2.maritalStatus.HCT = this.clientModelV2.spouses[0].HCT == 1 ? true : false;
        this.clientModelV2.maritalStatus.HCT2D = this.clientModelV2.spouses[0].HCT2D == 1 ? true : false;
      } else {
        this.clientModelV2.maritalStatus.maritalStatus = 'Single';
      }

      // //console.log(this.clientModelV2);

      // //console.log(typeof this.clientModelV2.spouses[0].previouslyMarried);
      // //console.log(this.clientModelV2.spouses.length > 1);

      if (this.clientModelV2.maritalStatus.maritalStatus === 'Single') {
        // Marital History
        this.clientModelV2.maritalHistory.previousSpouseCount = this.clientModelV2.spouses.length > 1 ? this.clientModelV2.spouses.length - 1 : 0;
        this.clientModelV2.maritalHistory.previouslyMarried = this.clientModelV2.spouses.length <= 1 ? false : true; //this.clientModelV2.spouses[0] && typeof this.clientModelV2.spouses[0].previouslyMarried === 'boolean' ? this.clientModelV2.spouses[0].previouslyMarried : this.clientModelV2.spouses.length > 1;
        this.clientModelV2.maritalHistory.alive = this.clientModelV2.spouses[0] && typeof this.clientModelV2.spouses[0].alive === 'undefined' ? true : this.clientModelV2.spouses[0] ? this.clientModelV2.spouses[0].alive : false;
        this.clientModelV2.maritalHistory.tenyears = this.clientModelV2.spouses[0] && typeof this.clientModelV2.spouses[0].tenyears === 'undefined' ? false : this.clientModelV2.spouses[0] ? this.clientModelV2.spouses[0].tenyears : false;

        this.clientModelV2.maritalHistory.spousePreviouslyMarried = false;
        this.clientModelV2.maritalHistory.spousesSpouseCount = 0;
        this.clientModelV2.maritalHistory.spousesSpouse = [];
      } else {
        // Marital History
        this.clientModelV2.maritalHistory.previousSpouseCount = this.clientModelV2.spouses.length > 1 ? this.clientModelV2.spouses.length - 1 : 0;
        // //console.log(this.clientModelV2.maritalHistory.previouslyMarried);
        this.clientModelV2.maritalHistory.previouslyMarried = this.clientModelV2.spouses.length <= 1 ? false : true; // this.clientModelV2.spouses[0] && typeof this.clientModelV2.spouses[0].previouslyMarried === 'boolean' ? this.clientModelV2.spouses[0].previouslyMarried : this.clientModelV2.spouses.length > 1;
        // //console.log(this.clientModelV2.maritalHistory.previouslyMarried);
        this.clientModelV2.maritalHistory.alive = this.clientModelV2.spouses[0] && typeof this.clientModelV2.spouses[0].alive === 'undefined' ? true : this.clientModelV2.spouses[0] ? this.clientModelV2.spouses[0].alive : false;
        this.clientModelV2.maritalHistory.tenyears = this.clientModelV2.spouses[0] && typeof this.clientModelV2.spouses[0].tenyears === 'undefined' ? false : this.clientModelV2.spouses[0] ? this.clientModelV2.spouses[0].tenyears : false;

        this.clientModelV2.spouses[0].maritalHistory = this.clientModelV2.spouses[0].maritalHistory || {};
        this.clientModelV2.maritalHistory.spousePreviouslyMarried = this.clientModelV2.spouses[0].maritalHistory.spousePreviouslyMarried || false;
        this.clientModelV2.maritalHistory.spousesSpouseCount = this.clientModelV2.spouses[0].maritalHistory.spousesSpouseCount || 0;
        this.clientModelV2.maritalHistory.spousesSpouse = this.clientModelV2.spouses[0].spousesSpouse || [];
      }

      //console.log(this.clientModelV2.maritalHistory.previousSpouseCount);

      // //console.log(this.clientModelV2.maritalHistory);

      // if (this.clientModelV2.spouses.length < 1 || !this.clientModelV2.spouses[0].previouslyMarried) {
      //   this.clientModelV2.maritalHistory.previouslyMarried = false;
      // } 

      // else if (typeof this.clientModelV2.spouses[0].previouslyMarried === 'undefined' && this.clientModelV2.spouses.length > 1) {
      //   this.clientModelV2.maritalHistory.previouslyMarried = true;
      // }

      // //console.log(client.clientProfile.LifeExpectancy);

      if (!client.clientProfile.LifeExpectancy || client.clientProfile.LifeExpectancy == null) {
        // //console.log(this.clientModelV2.generalInformation);
        if (this.clientModelV2.generalInformation.dobStr && this.clientModelV2.generalInformation.gender && this.clientModelV2.generalInformation.dobStr) {
          //here
          var leModel = this.clientModelV2.healthInformation;
          leModel.gender = this.clientModelV2.generalInformation.gender;
          leModel.dob = this.clientModelV2.generalInformation.dobStr;
          this.recalcLEV2(this.clientModelV2, 0, true);
        }
      }

      // Dependent Children
      var children = JSON.parse(client.clientProfile.Children) || [];

      this.clientModelV2.dependentChildren.children = children.children || children;
      this.clientModelV2.dependentChildren.hasKids = children.hasKids || children.length > 0;
      this.clientModelV2.dependentChildren.childrenCount = children.childrenCount || children.length;

    }
  }

  onMaritalStatusChange(status) {
    if (status != 'Single' || status != 'Widow') {

    } else {

    }
  }

  saveClientV2(client, directToReports) {

    if (!this.isSelectingAdvisor && this.modalData.ID == 0 && (Number(localStorage.getItem('roleId')) == 1 || Number(localStorage.getItem('roleId')) == 2)) {
      this.modalData.AdvisorID = this.selectedAdvisor.c.ID;
      this.modalData.AdvisorOrgID = this.selectedAdvisor.o.ID;
      // console.log("AdvisorID",this.modalData.AdvisorID);
    }

    if (this.canSave()) {
      var UserModel = {
        AdvisorID: this.modalData.AdvisorID || this.advisor.ID,
        OrganizationID: this.modalData.AdvisorOrgID || this.advisor.OrganizationID,
        ID: this.client.client ? this.client.client.ID : 0,
        Username: this.clientModelV2.generalInformation.email,
        Email: this.clientModelV2.generalInformation.email,
        FirstName: this.clientModelV2.generalInformation.firstName,
        LastName: this.clientModelV2.generalInformation.lastName,
        Address: this.clientModelV2.generalInformation.address,
        City: this.clientModelV2.generalInformation.city,
        State: this.clientModelV2.generalInformation.state,
        Zip: this.clientModelV2.generalInformation.zip,
        Phone: this.clientModelV2.generalInformation.phone,
        DOB: this.clientModelV2.generalInformation.dobStr,
        GenderID: Number(this.clientModelV2.generalInformation.gender),
      }

      // //console.log(UserModel);
      console.log(UserModel)

      var tempSpouses = [];
      var tempSpouse = {};

      //console.log(this.clientModelV2.spouses);

      for (var i = 0; i < this.clientModelV2.spouses.length; i++) {
        tempSpouse = {};
        for (var j in this.clientModelV2.spouses[i]) {
          if (j === "HCHBP") {
            tempSpouse[j] = this.clientModelV2.spouses[i][j] == true ? 1 : 0;
          } else if (j === "HCHC") {
            tempSpouse[j] = this.clientModelV2.spouses[i][j] == true ? 1 : 0;
          } else if (j === "HCT2D") {
            tempSpouse[j] = this.clientModelV2.spouses[i][j] == true ? 1 : 0;
          } else if (j === "HCCD") {
            tempSpouse[j] = this.clientModelV2.spouses[i][j] == true ? 1 : 0;
          } else if (j === "HCC") {
            tempSpouse[j] = this.clientModelV2.spouses[i][j] == true ? 1 : 0;
          } else if (j === "HCT") {
            tempSpouse[j] = this.clientModelV2.spouses[i][j] == true ? 1 : 0;
          } else if (j === "pia") {
            tempSpouse[j] = this.clientModelV2.spouses[i][j].length ? this.clientModelV2.spouses[i][j].replace(/,/g, "").replace("$", "") : 0;
          } else {
            tempSpouse[j] = this.clientModelV2.spouses[i][j];
          }
        }
        tempSpouses.push(tempSpouse);
      }

      var spouses = [];

      if (this.clientModelV2.maritalStatus.maritalStatus != 'Single') {
        spouses[0] = { PIAYears: {} };
        spouses[0].PIAYears.IncludePIA = this.clientModelV2.maritalStatus.PIAYears.includePIA;
        spouses[0].PIAYears.StartYear = this.clientModelV2.maritalStatus.PIAYears.startYear;
        spouses[0].PIAYears.EndYear = this.clientModelV2.maritalStatus.PIAYears.endYear;
        spouses[0].PIAYears.Years = this.clientModelV2.maritalStatus.PIAYears.years;
        spouses[0].previouslyMarried = this.clientModelV2.maritalHistory.previouslyMarried ? true : false;
        spouses[0].tenyears = this.clientModelV2.maritalHistory.tenyears;
        spouses[0].alive = this.clientModelV2.maritalHistory.alive;
        spouses[0].maritalStatus = this.clientModelV2.maritalStatus.maritalStatus;
        spouses[0].firstName = this.clientModelV2.maritalStatus.firstName;
        spouses[0].lastName = this.clientModelV2.maritalStatus.lastName;
        spouses[0].dob = this.clientModelV2.maritalStatus.dobStr;
        spouses[0].anniversary = this.clientModelV2.maritalStatus.anniversaryStr;
        spouses[0].currentIncome = this.getNumber(this.clientModelV2.maritalStatus.currentIncome);
        spouses[0].pia = this.clientModelV2.maritalStatus.pia.replace(/,/g, "").replace("$", "") || 0;
        spouses[0].gender = this.clientModelV2.maritalStatus.gender;
        spouses[0].LifeExpectancy = this.clientModelV2.maritalStatus.lifeExpectancy;
        spouses[0].retirementAge = this.clientModelV2.maritalStatus.retirementAge;
        spouses[0].state = this.clientModelV2.maritalStatus.retirementState;
        spouses[0].pension = this.clientModelV2.maritalStatus.pensionAmount || 0;
        spouses[0].includePension = this.clientModelV2.maritalStatus.includePension || false;
        spouses[0].pensionYear = this.clientModelV2.maritalStatus.pensionYears;
        spouses[0].pensionMonth = this.clientModelV2.maritalStatus.pensionMonths;
        spouses[0].substantialEarningYears = this.clientModelV2.maritalStatus.subEarnings;
        spouses[0].HCT2D = this.clientModelV2.maritalStatus.HCT2D == true ? 1 : 0;
        spouses[0].HCHBP = this.clientModelV2.maritalStatus.HCHBP == true ? 1 : 0;
        spouses[0].HCC = this.clientModelV2.maritalStatus.HCC == true ? 1 : 0;
        spouses[0].HCHC = this.clientModelV2.maritalStatus.HCHC == true ? 1 : 0;
        spouses[0].HCCD = this.clientModelV2.maritalStatus.HCCD == true ? 1 : 0;
        spouses[0].HCT = this.clientModelV2.maritalStatus.HCT == true ? 1 : 0;
        spouses[0].spousesSpouse = this.clientModelV2.maritalHistory.spousesSpouse || [];
        spouses[0].maritalHistory = this.clientModelV2.maritalHistory || {};
      } else {
        spouses[0] = { PIAYears: {} };
        spouses[0].maritalStatus = this.clientModelV2.maritalStatus.maritalStatus;
        spouses[0].pia = '';
        spouses[0].pension = '';
        spouses[0].previouslyMarried = this.clientModelV2.maritalHistory.previouslyMarried ? true : false;
      }

      if (tempSpouses.length > 1) {
        for (var spouse in tempSpouses) {
          if (Number(spouse) > 0) {
            spouses[spouse] = tempSpouses[spouse];
          }
        }
      }

      // BP - Added national average bool

      var ClientProfile = {
        CurrentIncome: this.getNumber(this.clientModelV2.financialInformation.currentIncome),
        IRR: this.getNumber(this.clientModelV2.financialInformation.irr),
        PIA: this.getNumber(this.clientModelV2.financialInformation.pia),
        RetirementAge: Number(this.clientModelV2.generalInformation.retirementAge),
        UseNationalAverage: Number(this.clientModelV2.generalInformation.useNationalAverage || 0) || 0,
        Pension: this.getNumber(this.clientModelV2.financialInformation.pensionAmount),
        PensionMonths: this.getNumber(Number(this.clientModelV2.financialInformation.pensionStartMonth)),
        PensionYears: this.getNumber(Number(this.clientModelV2.financialInformation.pensionStartYear)),
        SubstantialEarningYears: this.getNumber(Number(this.clientModelV2.financialInformation.pensionSubEarnings)),
        RetirementState: this.clientModelV2.generalInformation.retirementState,
        HCHBP: this.clientModelV2.healthInformation.HCHBP ? 1 : 0,
        HCHC: this.clientModelV2.healthInformation.HCHC ? 1 : 0,
        HCT2D: this.clientModelV2.healthInformation.HCT2D ? 1 : 0,
        HCCD: this.clientModelV2.healthInformation.HCCD ? 1 : 0,
        HCC: this.clientModelV2.healthInformation.HCC ? 1 : 0,
        HCT: this.clientModelV2.healthInformation.HCT ? 1 : 0,
        Spouses: JSON.stringify(spouses), //this.client.clientProfile.Spouses, // order them so first is always the one being claimed off of
        Children: this.clientModelV2.dependentChildren.hasKids ? JSON.stringify(this.clientModelV2.dependentChildren.children) : JSON.stringify([]), //this.client.clientProfile.Children,
        IncludePension: this.clientModelV2.financialInformation.hasPension ? 1 : 0,
        LifeExpectancy: Number(this.clientModelV2.healthInformation.lifeExpectancy),
        PIAYears: JSON.stringify(this.clientModelV2.financialInformation.PIAYears),
      }

      var RiskTolerance = null;

      // //console.log(ClientProfile);

      if (true) { // validate fields again?
        this.globalService.createClient(UserModel, ClientProfile, RiskTolerance)
          .subscribe(
            resp => {

              if (resp.type != 0) {

                if (!this.client.clientProfile) {
                  this.globalService.getClientsData()
                    .subscribe(
                      clients => {
                        var client;
                        // localStorage.setItem('selectedClient', resp.message);
                        UserModel.ID = resp.message;
                        this.snackBarService.add('To create a report for ' + UserModel.FirstName + ' ' + UserModel.LastName + ', please click ', 0, 1, 10000);

                      },
                      error => {
                        this.snackBarService.add('There was an issue creating new client, please try again later.', 1);
                        this.error = <any>error;

                      });
                } else {
                  this.snackBarService.add('Client has been updated', 0);

                }

                if (directToReports == true) {
                  localStorage.setItem('selectedClient', resp.message);
                  this.router.navigate(['reports/create']);
                  // //console.log(this.selectedAdvisor);

                  if (this.selectedAdvisor) {
                    // //console.log(client);
                    // //console.log(UserModel);
                    // //console.log(ClientProfile);
                  }
                }

                // localStorage.setItem('selectedAdvisor', ClientProfile.);
                // localStorage.setItem('selectedAdvisorID', client.AdvisorID);
                // localStorage.setItem('selectedAdvisorOrgID', client.AdvisorOrgID);
                // this.router.navigate(['reports/create']);
                this.close();

              } else {
                this.snackBarService.add('An error occured creating this client.', 1);
                this.close();
              }

            },
            error => {
              this.snackBarService.add('There was an issue creating new client, please try again later.', 1);
              this.error = <any>error;

            });

      } else {
        //this.snackBarService.add('Please make sure all fields are properly filled out', 1);
      }
    }
  }

  mapToOldObject(client) {
    return {
      client: {
        Address: '',
        Address2: '',
        AdvisorID: '',
        City: '',
        CreatedDate: '',
        DOB: '',
        Email: '',
        FirstName: '',
        GenderID: '',
        ID: '',
        IsActive: '',
        LastName: '',
        ModifiedBy: '',
        ModifiedDate: '',
        OrganizationID: '',
        Phone: '',
        RoleID: '',
        State: '',
        Username: '',
        Zip: '',
      },
      clientProfile: {
        Children: {},
        ClientID: '',
        CurrentIncome: '',
        HCC: '',
        HCCD: '',
        HCHBP: '',
        HCHC: '',
        HCT: '',
        HCT2D: '',
        IRR: '',
        IncludePension: '',
        LifeExpectancy: '',
        MaritalStatus: '',
        PIA: '',
        PIAYears: {},
        Pension: '',
        PensionMonths: '',
        PensionYears: '',
        RetirementAge: '',
        RetirementState: '',
        SpouseID: '',
        Spouses: [],
        SubstantialEarningYears: '',
      },

    }
  }

  ngAfterViewChecked() {
    // this.scrollEl.nativeElement.scrollTop = 0;
  }


  onClick(e): void {
    if (this.container.nativeElement.classList.contains('visible')) {

    }
  }

  open(): void {
    this.container.nativeElement.classList.remove('hidden');
    this.container.nativeElement.classList.add('visible');
    this.scrollEl.nativeElement.scrollTop = 0;
  }

  close(): void {
    this.container.nativeElement.classList.remove('visible');
    this.container.nativeElement.classList.add('hidden');

    this.selectedDocument = {
      title: '',
      description: '',
      category: '',
      url: '',
    }

    this.selectedDocEvent = {};
    this.selectedDocFilePath = '';

    this.modalData = {};
    // this.modalName = '';

    this.createClientModel = {
      client: {},
      clientProfile: {
        HCHBP: false,
        HCHC: false,
        HCT2D: false,
        HCCD: false,
        HCC: false,
        HCT: false,
        clientSpouses: [],
        clientChildren: [],
      },
    };

    this.editClientModel = {
      loaded: false,
      client: {},
      clientProfile: {
        HCHBP: false,
        HCHC: false,
        HCT2D: false,
        HCCD: false,
        HCC: false,
        HCT: false,
        clientSpouses: [],
        clientChildren: [],
      },
    }


    this.selectedAdvisor = null;
    this.selectedOrganization = null;
    this.isSelectingAdvisor = false;
    this.client = {};

    this.modalService.add(this.modalName + 'Closed');

    // this.createClientModel = {
    //   client: {},
    //   clientProfile: {},
    //   clientSpouse: {},
    //   clientChildren: {}
    // };
  }


  createOrganization(organizationName, organizationEmail, organizationPhone, organizationAddress, organizationCity, organizationState, organizationZip) {

    var OrganizationModel = {
      OrgName: organizationName.value,
      Email: organizationEmail.value,
      Phone: organizationPhone.value,
      Address: organizationAddress.value,
      Address2: '',
      City: organizationCity.value,
      State: organizationState.value,
      Zip: organizationZip.value,
      ParentID: 1,
    }

    this.globalService.createOrganization(OrganizationModel)
      .subscribe(
        resp => {
          if (resp.error === 1) {
            this.snackBarService.add(resp.message, 1);
          } else if (resp.error === 0) {
            this.snackBarService.add(resp.message, 0);
            this.close();
          }
        },
        error => this.error = <any>error);
  }

  createAdvisor(advisorFirstName, advisorLastName, advisorDOB, advisorEmail, advisorPhone, advisorAddress, advisorCity, advisorState, advisorZip) {
    var UserModel = {
      ID: 0,
      FirstName: advisorFirstName.value,
      LastName: advisorLastName.value,
      DOB: advisorDOB.value,
      Email: advisorEmail.value,
      Phone: advisorPhone.value,
      Address: advisorAddress.value,
      City: advisorCity.value,
      State: advisorState.value,
      Zip: advisorZip.value,
      RoleID: 3,
    }

    this.globalService.createAdvisor(UserModel)
      .subscribe(
        resp => { },
        error => this.error = <any>error);
  }

  updateClient() {

    var UserModel = {
      //AdvisorID: this.advisor.ID,
      //OrganizationID: this.advisor.OrganizationID,
      ID: this.client.client.ID,
      Username: this.editClientModel.client.Email,
      Email: this.editClientModel.client.Email,
      FirstName: this.editClientModel.client.FirstName,
      LastName: this.editClientModel.client.LastName,
      Address: this.editClientModel.client.Address,
      City: this.editClientModel.client.City,
      State: this.editClientModel.client.State,
      Zip: this.editClientModel.client.Zip,
      Phone: this.editClientModel.client.Phone,
      DOB: this.editClientModel.client.DOB,
      GenderID: this.editClientModel.client.GenderID,
    }

    if (this.editClientModel.clientProfile.Spouses.length) {
      for (var k in this.editClientModel.clientProfile.Spouses) {
        this.editClientModel.clientProfile.Spouses[k].currentIncome = this.getNumber(this.editClientModel.clientProfile.Spouses[k].currentIncome);
        this.editClientModel.clientProfile.Spouses[k].pension = this.getNumber(this.editClientModel.clientProfile.Spouses[k].pension);
      }
    }

    var tempSpouses = [];
    var tempSpouse = {};

    for (var i = 0; i < this.editClientModel.clientProfile.Spouses.length; i++) {
      tempSpouse = {};
      for (var j in this.editClientModel.clientProfile.Spouses[i]) {
        if (j === "HCHBP") {
          tempSpouse[j] = this.editClientModel.clientProfile.Spouses[i][j] == true ? 1 : 0;
        } else if (j === "HCHC") {
          tempSpouse[j] = this.editClientModel.clientProfile.Spouses[i][j] == true ? 1 : 0;
        } else if (j === "HCT2D") {
          tempSpouse[j] = this.editClientModel.clientProfile.Spouses[i][j] == true ? 1 : 0;
        } else if (j === "HCCD") {
          tempSpouse[j] = this.editClientModel.clientProfile.Spouses[i][j] == true ? 1 : 0;
        } else if (j === "HCC") {
          tempSpouse[j] = this.editClientModel.clientProfile.Spouses[i][j] == true ? 1 : 0;
        } else if (j === "HCT") {
          tempSpouse[j] = this.editClientModel.clientProfile.Spouses[i][j] == true ? 1 : 0;
        } else {
          tempSpouse[j] = this.editClientModel.clientProfile.Spouses[i][j];
        }
      }
      tempSpouses.push(tempSpouse);
    }

    var ClientProfile = {
      CurrentIncome: this.getNumber(this.editClientModel.clientProfile.CurrentIncome),
      IRR: this.getNumber(this.editClientModel.clientProfile.IRR),
      PIA: this.getNumber(this.editClientModel.clientProfile.PIA),
      RetirementAge: this.getNumber(Number(this.editClientModel.clientProfile.RetirementAge)),
      Pension: this.getNumber(this.editClientModel.clientProfile.Pension),
      PensionMonths: this.getNumber(Number(this.editClientModel.clientProfile.PensionMonths)),
      PensionYears: this.getNumber(Number(this.editClientModel.clientProfile.PensionYears)),
      SubstantialEarningYears: this.getNumber(Number(this.editClientModel.clientProfile.SubstantialEarningYears)),
      RetirementState: this.editClientModel.clientProfile.RetirementState,
      HCHBP: this.editClientModel.clientProfile.HCHBP ? 1 : 0,
      HCHC: this.editClientModel.clientProfile.HCHC ? 1 : 0,
      HCT2D: this.editClientModel.clientProfile.HCT2D ? 1 : 0,
      HCCD: this.editClientModel.clientProfile.HCCD ? 1 : 0,
      HCC: this.editClientModel.clientProfile.HCC ? 1 : 0,
      HCT: this.editClientModel.clientProfile.HCT ? 1 : 0,

      HCALZ: this.editClientModel.clientProfile.HCALZ ? 1 : 0,
      HCPARK: this.editClientModel.clientProfile.HCPARK ? 1 : 0,
      HCAMP: this.editClientModel.clientProfile.HCAMP ? 1 : 0,
      HCPTSD: this.editClientModel.clientProfile.HCPTSD ? 1 : 0,
      HCOBS: this.editClientModel.clientProfile.HCOBS ? 1 : 0,

      Spouses: JSON.stringify(tempSpouses), // order them so first is always the one being claimed off of
      Children: JSON.stringify(this.editClientModel.clientProfile.Children),
      IncludePension: this.editClientModel.clientProfile.IncludePension ? 1 : 0,
      LifeExpectancy: Number(this.editClientModel.clientProfile.LifeExpectancy),
      PIAYears: JSON.stringify(this.editClientModel.clientProfile.PIAYears),
    }

    var RiskTolerance = null;

    var validationErrors = this.validateEditClient();

    // //console.log(this.editClientModel);
    // //console.log(UserModel, ClientProfile);

    if (validationErrors) {
      this.globalService.createClient(UserModel, ClientProfile, RiskTolerance)
        .subscribe(
          resp => {
            if (resp.type != 0) {
              this.snackBarService.add('Client has been updated', 0);
              this.close();
            } else {
              this.snackBarService.add('An error occured updating this client.', 1);
            }
          },
          error => {
            this.snackBarService.add('There was an issue updating this client, please try again later.', 1);
            this.error = <any>error;
          });
    } else {
      this.snackBarService.add('Please make sure all fields are properly filled out', 1);
    }


    // if (validationErrors.length) {
    //   this.snackBarService.add('Please make sure all fields are properly filled out', 1);
    // } else {
    //   this.globalService.createClient(UserModel, ClientProfile)
    //     .subscribe(
    //     resp => {

    //       if (resp.error === 1) {
    //         this.snackBarService.add('Client failed to update', 1);
    //       } else if (resp.error === 0) {
    //         this.snackBarService.add('Client has been updated', 0);
    //         this.close();
    //       }
    //     },
    //     error => {
    //       this.error = <any>error;
    //     });
    // }
  }

  createClient() {
    var UserModel = {
      AdvisorID: this.advisor.ID,
      OrganizationID: this.advisor.OrganizationID,
      Username: this.createClientModel.client.email || " ",
      Email: this.createClientModel.client.email || " ",
      FirstName: this.createClientModel.client.firstName,
      LastName: this.createClientModel.client.lastName,
      Address: this.createClientModel.client.address,
      City: this.createClientModel.client.city,
      State: this.createClientModel.client.state,
      Zip: Number(this.createClientModel.client.zip.toString().substring(0, 5)),
      Phone: this.createClientModel.client.phone,
      DOB: this.createClientModel.client.DOB,
      GenderID: Number(this.createClientModel.client.gender),
    }


    if (this.createClientModel.clientProfile.clientSpouses.length) {
      for (var k in this.createClientModel.clientProfile.clientSpouses) {
        this.createClientModel.clientProfile.clientSpouses[k].currentIncome = this.getNumber(this.createClientModel.clientProfile.clientSpouses[k].currentIncome);
        this.createClientModel.clientProfile.clientSpouses[k].pension = this.getNumber(this.createClientModel.clientProfile.clientSpouses[k].pension);
        this.createClientModel.clientProfile.clientSpouses[k].PIAYears = this.createClientModel.clientProfile.clientSpouses[k].PIAYears;
      }
    }

    var tempSpouses = [];
    var tempSpouse = {};

    for (var i = 0; i < this.createClientModel.clientProfile.clientSpouses.length; i++) {
      tempSpouse = {};
      for (var j in this.createClientModel.clientProfile.clientSpouses[i]) {
        if (j === "HCHBP") {
          tempSpouse[j] = this.createClientModel.clientProfile.clientSpouses[i][j] == true ? 1 : 0;
        } else if (j === "HCHC") {
          tempSpouse[j] = this.createClientModel.clientProfile.clientSpouses[i][j] == true ? 1 : 0;
        } else if (j === "HCT2D") {
          tempSpouse[j] = this.createClientModel.clientProfile.clientSpouses[i][j] == true ? 1 : 0;
        } else if (j === "HCCD") {
          tempSpouse[j] = this.createClientModel.clientProfile.clientSpouses[i][j] == true ? 1 : 0;
        } else if (j === "HCC") {
          tempSpouse[j] = this.createClientModel.clientProfile.clientSpouses[i][j] == true ? 1 : 0;
        } else if (j === "HCT") {
          tempSpouse[j] = this.createClientModel.clientProfile.clientSpouses[i][j] == true ? 1 : 0;
        } else {
          tempSpouse[j] = this.createClientModel.clientProfile.clientSpouses[i][j];
        }
      }

      tempSpouses.push(tempSpouse);
    }

    var ClientProfile = {
      //MaritalStatus: '',// I don't think we need this anymore -> get from clientProfile spouses   //this.convertMartialStatus(this.createClientModel.clientProfile.maritalStatus),
      CurrentIncome: this.getNumber(this.createClientModel.clientProfile.currentIncome),
      IRR: this.getNumber(this.createClientModel.clientProfile.IRR),
      PIA: this.getNumber(this.createClientModel.clientProfile.PIA),
      PIAYears: JSON.stringify(this.createClientModel.clientProfile.PIAYears),
      RetirementAge: this.getNumber(Number(this.createClientModel.clientProfile.retirementAge)),
      Pension: this.getNumber(this.createClientModel.clientProfile.pension),
      PensionMonths: this.getNumber(Number(this.createClientModel.clientProfile.pensionMonth)),
      PensionYears: this.getNumber(Number(this.createClientModel.clientProfile.pensionYear)),
      SubstantialEarningYears: this.getNumber(Number(this.createClientModel.clientProfile.substantialEarningYears)),
      RetirementState: this.createClientModel.clientProfile.retirementState,
      HCHBP: this.createClientModel.clientProfile.HCHBP ? 1 : 0,
      HCHC: this.createClientModel.clientProfile.HCHC ? 1 : 0,
      HCT2D: this.createClientModel.clientProfile.HCT2D ? 1 : 0,
      HCCD: this.createClientModel.clientProfile.HCCD ? 1 : 0,
      HCC: this.createClientModel.clientProfile.HCC ? 1 : 0,
      HCT: this.createClientModel.clientProfile.HCT ? 1 : 0,

      HCALZ: this.createClientModel.clientProfile.HCALZ ? 1 : 0,
      HCPARK: this.createClientModel.clientProfile.HCPARK ? 1 : 0,
      HCAMP: this.createClientModel.clientProfile.HCAMP ? 1 : 0,
      HCPTSD: this.createClientModel.clientProfile.HCPTSD ? 1 : 0,
      HCOBS: this.createClientModel.clientProfile.HCOBS ? 1 : 0,

      Spouses: JSON.stringify(tempSpouses), // order them so first is always the one being claimed off of
      Children: JSON.stringify(this.createClientModel.clientProfile.clientChildren),
      IncludePension: this.createClientModel.clientProfile.includePension ? 1 : 0,
      LifeExpectancy: Number(this.createClientModel.clientProfile.LifeExpectancy),
    }

    var RiskTolerance = null;

    var validationErrors = this.validateCreateClient();

    if (validationErrors) {
      this.globalService.createClient(UserModel, ClientProfile, RiskTolerance)
        .subscribe(
          resp => {
            if (resp.type != 0) {
              this.close();
              this.globalService.getClientsData()
                .subscribe(
                  clients => {
                    var client = clients[clients.length - 1].c || clients[clients.length - 1];

                    localStorage.setItem('selectedClient', client.ID);
                    this.snackBarService.add('To create a report for ' + client.FirstName + ' ' + client.LastName + ', please click ', 0, 1, 10000);
                  },
                  error => {
                    this.snackBarService.add('There was an issue creating new client, please try again later.', 1);
                    this.error = <any>error;
                  });
            } else {
              this.snackBarService.add('An error occured creating this client.', 1);
            }

          },
          error => {
            this.snackBarService.add('There was an issue creating new client, please try again later.', 1);
            this.error = <any>error;

          });
    } else {
      this.snackBarService.add('Please make sure all fields are properly filled out', 1);
    }




    ////console.log(UserModel, ClientProfile);

    // if (validationErrors.length) {
    //   this.snackBarService.add('Please make sure all fields are properly filled out', 1);
    // } else {
    //   this.globalService.createClient(UserModel, ClientProfile)
    //   .subscribe(
    //   resp => { 

    //     if (resp.error === 1) {

    //       this.snackBarService.add('User not created', 1);
    //     } else if (resp.error === 0) {

    //       this.snackBarService.add('New client has been created', 0);
    //       this.close();
    //     }
    //   },
    //   error => { 
    //     this.error = <any>error;

    //   });
    // }
  }

  removeSpouse(index, from) {

    if (!this.editClientModel.clientProfile.Spouses) {
      this.editClientModel.clientProfile.Spouses = [];
    }

    if (from == 'edit') {
      this.editClientModel.clientProfile.Spouses.splice(index, 1);
    } else if (from == 'create') {
      this.createClientModel.clientProfile.clientSpouses.splice(index, 1);
    }

    if (from == 'marital-history') {
      this.clientModelV2.maritalHistory.previousSpouseCount = this.clientModelV2.maritalHistory.previousSpouseCount - 1;
      this.clientModelV2.spouses.splice(index + 1, 1);
    } else if (from == 'spouse-history') {
      this.clientModelV2.maritalHistory.spousesSpouseCount = this.clientModelV2.maritalHistory.spousesSpouseCount - 1;
      this.clientModelV2.maritalHistory.spousesSpouse.splice(index, 1);
    }

    this.validateAllFields();
  }

  spouseMaritalChange(e, partner) {
    // //console.log('e', e, partner);
    // partner
  }

  addPartner(from) {
    if (!this.editClientModel.clientProfile.Spouses) {
      this.editClientModel.clientProfile.Spouses = [];
    }

    if (from == 'edit') {
      this.editClientModel.clientProfile.Spouses.push({
        PIAYears: {
          IncludePIA: false,
        },
        tenyears: true,
        alive: true,
        // LifeExpectancy: 88,
      });
    }
    else if (from == 'create') {
      this.createClientModel.clientProfile.clientSpouses.push({
        PIAYears: {
          IncludePIA: false,
        },
        tenyears: true,
        alive: true,
        // LifeExpectancy: 88,
      });
    }
  }

  removeChild(index, from) {
    if (!this.editClientModel.clientProfile.Children) {
      this.editClientModel.clientProfile.Children = [];
    }

    if (from == 'edit')
      this.editClientModel.clientProfile.Children.splice(index, 1);
    else if (from == 'create')
      this.createClientModel.clientProfile.clientChildren.splice(index, 1);
  }

  addDependentChild(from) {
    if (!this.editClientModel.clientProfile.Children) {
      this.editClientModel.clientProfile.Children = [];
    }

    if (from == 'edit') {
      this.editClientModel.clientProfile.Children.push({});
    }
    else if (from == 'create') {
      this.createClientModel.clientProfile.clientChildren.push({});
    }
  }

  convertMartialStatus(status) {
    if (status === "Single") {
      return 0;
    } else if (status === "Married") {
      return 1;
    } else if (status === "Divorced") {
      return 2;
    } else if (status === "Widowed") {
      return 3;
    }

  }



  validateString(val, isRequired) {
    var regex = /^[a-zA-Z ]{2,30}$/;
    return val ? regex.test(val) : !isRequired;
  }

  // validateNumber(val) {
  //   var regex = /^(0|[1-9]\d*)$/;
  //   return val ? regex.test(val) : true;
  // }

  validatePhoneNumber(val, isRequired) {
    val = val ? val.toString() : '';
    var numbers = val ? val.match(/\d/g) : '';
    return val ? numbers.length === 10 : !isRequired;
  }

  validateZip(val, isRequired) {
    // var regex = /^\d{5}(?:[-\s]\d{4})?$/;
    // return val ? regex.test(val) : !isRequired;
    // return (Number(val) && val.toString().length > 4) && isRequired;
    return true;
  }

  validateCurrency(val, min, max, isRequired) {
    val = val ? val.toString() : '';
    var numbers = val ? val.match(/\d/g).join('') : '';
    return val ? (numbers >= min && numbers < max) ? true : false : !isRequired;
  }

  validateEmail(val, isRequired) {
    var regex = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
    return val ? regex.test(val) : !isRequired;
  }

  // validateDropDown(val) {
  //   return val ? val.length > 0 : true;
  // }

  validateDate(val, isRequired) {
    // //console.log(val);
    var regex = /^([0-9]{1}|[0-9]{2})\/([0-9]{1}|[0-9]{2})\/([0-9]{4})$/;
    return val ? regex.test(val) : !isRequired;
  }

  validatePercent(val, min, max, isRequired) {
    val = val ? val.toString() : '';
    var numbers = val ? val.match(/\d/g).join('') : '';
    return val ? (numbers >= min && numbers < max) ? true : false : !isRequired;
  }

  validateNumber(val, min, max, isRequired) {
    val = val ? val.toString() : '';
    var numbers = val ? val.match(/\d/g).join('') : '';
    return val ? (numbers >= min && numbers < max) ? true : false : !isRequired;
  }

  getNumber(val) {
    val = val ? val.toString() : '';
    val = val.replace('$', '').replace(',', '');
    var numbers = val ? val.match(/\d/g).join('') : '';
    return val ? numbers : 0
  }

  formatString(model, field) {
    if (model[field])
      model[field] = model[field].charAt(0).toUpperCase() + model[field].slice(1);
  }




  formatNumber(model, field) {
    var numbers = model[field] ? model[field].match(/\d/g) : '';
    model[field] = numbers.join('');
  }

  formatPercent(model, field, e) {
    if (model[field]) {
      model[field] = model[field].toString();
      var numbers = model[field] ? model[field].match(/\d/g) : '';
      if (e.keyCode && (e.keyCode == 8 || e.keyCode == 46))
        numbers.pop();

      model[field] = numbers.join('') + '%';
    }
  }

  formatCurrency(model, field) {
    if (model[field]) {
      model[field] = model[field].toString();
      var numbers = model[field] ? model[field].match(/\d/g) : '';
      model[field] = '$' + numbers.join('').toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    }
  }

  formatCurrencyV2(amount) {
    amount = amount.toString().replace(/,/g, "").replace("$", "");
    return Utils.formatToCurrency(amount);
  }

  formatPhoneNumber(model, field) {
    if (model[field]) {
      model[field] = model[field].toString();
      var numbers = model[field] ? model[field].match(/\d/g) : '';
      // //console.log(numbers)
      if (numbers.length < 3) {
        model[field] = "(" + numbers.join('');
      } else if (numbers.length < 4) {
        model[field] = "(" + numbers.join('') + ")";
      } else if (numbers.length < 7) {
        model[field] = "(" + numbers.join('').substring(0, 3) + ") " + numbers.join('').substring(3, numbers.length);
      } else if (numbers.length >= 7) {
        model[field] = "(" + numbers.join('').substring(0, 3) + ") " + numbers.join('').substring(3, 6) + "-" + numbers.join('').substring(6, 10);
      }
    }

  }

  validateCreateClient() {
    var result = true;

    // result = result && this.validateEmail(this.createClientModel.client.email, true);
    result = result && this.validateString(this.createClientModel.client.firstName, true);
    result = result && this.validateString(this.createClientModel.client.lastName, true);

    result = result && this.validateString(this.createClientModel.client.state, false);
    result = result && this.validateZip(this.createClientModel.client.zip, false);
    result = result && this.validatePhoneNumber(this.createClientModel.client.phone, false);
    result = result && this.validateDate(this.createClientModel.client.DOB, true);
    result = result && this.validateNumber(this.createClientModel.client.gender, 1, 3, true);

    result = result && this.validateCurrency(this.createClientModel.clientProfile.currentIncome, 0, 1000000, true);
    result = result && this.validatePercent(this.createClientModel.clientProfile.IRR, 50, 201, true);
    result = result && this.validateCurrency(this.createClientModel.clientProfile.PIA, 0, 5000, true);
    result = result && this.validateNumber(this.createClientModel.clientProfile.retirementAge, 1, 71, true);
    result = result && this.validateCurrency(this.createClientModel.clientProfile.pension, 1, 400000, false);
    result = result && this.validateNumber(this.createClientModel.clientProfile.pensionMonth, 1, 13, false);
    result = result && this.validateNumber(this.createClientModel.clientProfile.pensionYear, 2000, 2061, false);
    result = result && this.validateNumber(this.createClientModel.clientProfile.substantialEarningYears, 0, 31, false);
    result = result && this.validateString(this.createClientModel.clientProfile.retirementState, true);

    for (var k in this.createClientModel.clientProfile.clientSpouses) {
      if (this.createClientModel.clientProfile.clientSpouses[k].maritalStatus == 'Married') {
        result = result && this.validateString(this.createClientModel.clientProfile.clientSpouses[k].maritalStatus, true);
        result = result && this.validateString(this.createClientModel.clientProfile.clientSpouses[k].firstName, true);
        result = result && this.validateString(this.createClientModel.clientProfile.clientSpouses[k].lastName, true);
        result = result && this.validateNumber(this.createClientModel.clientProfile.clientSpouses[k].gender, 1, 3, true);
        result = result && this.validateCurrency(this.createClientModel.clientProfile.clientSpouses[k].pia, 0, 10001, false);
        result = result && this.validateDate(this.createClientModel.clientProfile.clientSpouses[k].dob, true);
        result = result && this.validateCurrency(this.createClientModel.clientProfile.clientSpouses[k].currentIncome, 0, 1000000, true);
        result = result && this.validateCurrency(this.createClientModel.clientProfile.clientSpouses[k].pension, 0, 400000, false);
        result = result && this.validateNumber(this.createClientModel.clientProfile.clientSpouses[k].pensionYear, 2000, 2061, false);
        result = result && this.validateNumber(this.createClientModel.clientProfile.clientSpouses[k].pensionMonth, 1, 13, false);
        result = result && this.validateNumber(this.createClientModel.clientProfile.clientSpouses[k].substantialEarningYears, 1, 400000, false);
        result = result && this.validateNumber(this.createClientModel.clientProfile.clientSpouses[k].retirementAge, 1, 71, true);
        result = result && this.validateString(this.createClientModel.clientProfile.clientSpouses[k].state, true);
      } else if (this.createClientModel.clientProfile.clientSpouses[k].maritalStatus == 'Divorced') {
        result = result && this.validateString(this.createClientModel.clientProfile.clientSpouses[k].maritalStatus, true);
        result = result && this.validateString(this.createClientModel.clientProfile.clientSpouses[k].firstName, true);
        result = result && this.validateString(this.createClientModel.clientProfile.clientSpouses[k].lastName, true);
        result = result && this.validateCurrency(this.createClientModel.clientProfile.clientSpouses[k].pia, 0, 10001, false);

        if (this.createClientModel.clientProfile.clientSpouses[k].alive == 'true') {
          result = result && this.validateDate(this.createClientModel.clientProfile.clientSpouses[k].dob, true);
          result = result && this.validateNumber(this.createClientModel.clientProfile.clientSpouses[k].gender, 1, 3, true);
        }

        result = result && this.validateCurrency(this.createClientModel.clientProfile.clientSpouses[k].pension, 0, 400000, false);
        result = result && this.validateNumber(this.createClientModel.clientProfile.clientSpouses[k].pensionYear, 2000, 2061, false);
        result = result && this.validateNumber(this.createClientModel.clientProfile.clientSpouses[k].pensionMonth, 1, 13, false);
        result = result && this.validateNumber(this.createClientModel.clientProfile.clientSpouses[k].substantialEarningYears, 1, 400000, false);
      } else if (this.createClientModel.clientProfile.clientSpouses[k].maritalStatus == 'Widowed') {
        result = result && this.validateString(this.createClientModel.clientProfile.clientSpouses[k].maritalStatus, true);
        result = result && this.validateString(this.createClientModel.clientProfile.clientSpouses[k].firstName, true);
        result = result && this.validateString(this.createClientModel.clientProfile.clientSpouses[k].lastName, true);
        result = result && this.validateCurrency(this.createClientModel.clientProfile.clientSpouses[k].pia, 0, 10001, true);
        // result = result && this.validateCurrency(this.editClientModel.clientProfile.Spouses[k].pension, 1, 400000, false);
        // result = result && this.validateNumber(this.editClientModel.clientProfile.Spouses[k].pensionYear, 2000, 2061, false);
        // result = result && this.validateNumber(this.editClientModel.clientProfile.Spouses[k].pensionMonth, 1, 13, false);
        // result = result && this.validateNumber(this.editClientModel.clientProfile.Spouses[k].substantialEarningYears, 1, 400000, false);
      }
    }
    // //console.log(result);
    return result;
  }


  validateEditClient() {
    var result = true;

    // result = result && this.validateEmail(this.editClientModel.client.Email, true);
    result = result && this.validateString(this.editClientModel.client.FirstName, true);
    result = result && this.validateString(this.editClientModel.client.LastName, true);
    result = result && this.validateString(this.editClientModel.client.State, false);
    result = result && this.validateZip(this.editClientModel.client.Zip, false);
    result = result && this.validatePhoneNumber(this.editClientModel.client.Phone, false);
    result = result && this.validateDate(this.editClientModel.client.DOB, true);
    result = result && this.validateNumber(this.editClientModel.client.GenderID, 1, 3, true);

    result = result && this.validateCurrency(this.editClientModel.clientProfile.CurrentIncome, 0, 1000000, true);
    result = result && this.validatePercent(this.editClientModel.clientProfile.IRR, 50, 201, true);
    result = result && this.validateCurrency(this.editClientModel.clientProfile.PIA, 0, 5000, true);
    result = result && this.validateNumber(this.editClientModel.clientProfile.RetirementAge, 1, 71, true);
    result = result && this.validateCurrency(this.editClientModel.clientProfile.Pension, 0, 400000, false);
    result = result && this.validateNumber(this.editClientModel.clientProfile.PensionMonth, 1, 13, false);
    // //console.log('result', result);
    result = result && this.validateNumber(this.editClientModel.clientProfile.PensionYear, 2000, 2061, false);
    result = result && this.validateNumber(this.editClientModel.clientProfile.SubstantialEarningYears, 0, 31, false);
    result = result && this.validateString(this.editClientModel.clientProfile.RetirementState, true);
    // //console.log(this.editClientModel.clientProfile);
    for (var k in this.editClientModel.clientProfile.Spouses) {
      // //console.log('here ', this.editClientModel.clientProfile.Spouses[k])
      if (this.editClientModel.clientProfile.Spouses[k].maritalStatus == 'Married') {
        result = result && this.validateString(this.editClientModel.clientProfile.Spouses[k].maritalStatus, true);
        result = result && this.validateString(this.editClientModel.clientProfile.Spouses[k].firstName, true);
        result = result && this.validateString(this.editClientModel.clientProfile.Spouses[k].lastName, true);
        result = result && this.validateNumber(this.editClientModel.clientProfile.Spouses[k].gender, 1, 3, true);
        result = result && this.validateCurrency(this.editClientModel.clientProfile.Spouses[k].pia, 0, 10001, false);
        result = result && this.validateDate(this.editClientModel.clientProfile.Spouses[k].dob, true);
        result = result && this.validateCurrency(this.editClientModel.clientProfile.Spouses[k].currentIncome, 0, 1000000, true);
        result = result && this.validateCurrency(this.editClientModel.clientProfile.Spouses[k].pension, 0, 400000, false);
        result = result && this.validateNumber(this.editClientModel.clientProfile.Spouses[k].pensionYear, 2000, 2061, false);
        result = result && this.validateNumber(this.editClientModel.clientProfile.Spouses[k].pensionMonth, 1, 13, false);
        result = result && this.validateNumber(this.editClientModel.clientProfile.Spouses[k].substantialEarningYears, 1, 400000, false);
        result = result && this.validateNumber(this.editClientModel.clientProfile.Spouses[k].retirementAge, 1, 71, true);
        result = result && this.validateString(this.editClientModel.clientProfile.Spouses[k].state, true);
      } else if (this.editClientModel.clientProfile.Spouses[k].maritalStatus == 'Divorced') {
        result = result && this.validateString(this.editClientModel.clientProfile.Spouses[k].maritalStatus, true);
        result = result && this.validateString(this.editClientModel.clientProfile.Spouses[k].firstName, true);
        result = result && this.validateString(this.editClientModel.clientProfile.Spouses[k].lastName, true);
        result = result && this.validateCurrency(this.editClientModel.clientProfile.Spouses[k].pia, 0, 10001, true);

        if (this.editClientModel.clientProfile.Spouses[k].alive == "true") {
          result = result && this.validateDate(this.editClientModel.clientProfile.Spouses[k].dob, true);
          result = result && this.validateNumber(this.editClientModel.clientProfile.Spouses[k].gender, 1, 3, true);
        }

        result = result && this.validateCurrency(this.editClientModel.clientProfile.Spouses[k].pension, 0, 400000, false);
        result = result && this.validateNumber(this.editClientModel.clientProfile.Spouses[k].pensionYear, 2000, 2061, false);
        result = result && this.validateNumber(this.editClientModel.clientProfile.Spouses[k].pensionMonth, 1, 13, false);
        result = result && this.validateNumber(this.editClientModel.clientProfile.Spouses[k].substantialEarningYears, 1, 400000, false);
      } else if (this.editClientModel.clientProfile.Spouses[k].maritalStatus == 'Widowed') {
        result = result && this.validateString(this.editClientModel.clientProfile.Spouses[k].maritalStatus, true);
        result = result && this.validateString(this.editClientModel.clientProfile.Spouses[k].firstName, true);
        result = result && this.validateString(this.editClientModel.clientProfile.Spouses[k].lastName, true);
        result = result && this.validateCurrency(this.editClientModel.clientProfile.Spouses[k].pia, 0, 10001, true);
        // result = result && this.validateCurrency(this.editClientModel.clientProfile.Spouses[k].pension, 1, 400000, false);
        // result = result && this.validateNumber(this.editClientModel.clientProfile.Spouses[k].pensionYear, 2000, 2061, false);
        // result = result && this.validateNumber(this.editClientModel.clientProfile.Spouses[k].pensionMonth, 1, 13, false);
        // result = result && this.validateNumber(this.editClientModel.clientProfile.Spouses[k].substantialEarningYears, 1, 400000, false);
      } else {
        result = false;
      }



      // if (this.editClientModel.clientProfile.Spouses[k].maritalStatus == 'Married') {
      //   result = result && this.validateString(this.editClientModel.clientProfile.Spouses[k].maritalStatus, true);
      //   result = result && this.validateString(this.editClientModel.clientProfile.Spouses[k].firstName, true);
      //   result = result && this.validateString(this.editClientModel.clientProfile.Spouses[k].lastName, true);
      //   result = result && this.validateNumber(this.editClientModel.clientProfile.Spouses[k].gender, 1, 3, true);
      //   result = result && this.validateDate(this.editClientModel.clientProfile.Spouses[k].dob, true);
      //   result = result && this.validateCurrency(this.editClientModel.clientProfile.Spouses[k].currentIncome, 0, 1000000, true);
      //   result = result && this.validateCurrency(this.editClientModel.clientProfile.Spouses[k].pension, 1, 400000, false);
      //   result = result && this.validateNumber(this.editClientModel.clientProfile.Spouses[k].pensionYear, 2000, 2061, false);
      //   result = result && this.validateNumber(this.editClientModel.clientProfile.Spouses[k].pensionMonth, 1, 13, false);
      //   result = result && this.validateNumber(this.editClientModel.clientProfile.Spouses[k].substantialEarningYears, 1, 400000, false);
      //   result = result && this.validateNumber(this.editClientModel.clientProfile.Spouses[k].retirementAge, 1, 71, true);
      //   result = result && this.validateString(this.editClientModel.clientProfile.Spouses[k].state, true);
      // } 
    }


    return result;
  }

  formatEditClientModel() {
    // this.(this.createClientModel.client.email);
    this.formatString(this.editClientModel.client, 'firstName');
    this.formatString(this.editClientModel.client, 'lastName');
    // this.formatString(this.createClientModel.client.state);
    // this.formatNumber(this.createClientModel.client, 'zip');
    this.formatPhoneNumber(this.editClientModel.client, 'phone');
    // this.format(this.editClientModel.client.DOB);
    // this.validateNumber(this.editClientModel.client.gender, 1, 3);

    this.formatCurrency(this.editClientModel.clientProfile, 'CurrentIncome');
    this.formatPercent(this.editClientModel.clientProfile, 'IRR', {});
    this.formatCurrency(this.editClientModel.clientProfile, 'PIA');
    // this.validateNumber(this.editClientModel.clientProfile.retirementAge, 1, 71);
    this.formatCurrency(this.editClientModel.clientProfile, 'pension');
    // this.validateNumber(this.editClientModel.clientProfile.pensionMonth, 1, 13);
    // this.validateNumber(this.editClientModel.clientProfile.pensionYear, 2000, 2061);
    // this.validateNumber(this.editClientModel.clientProfile.substantialEarningYears, 0, 31);
    // this.validateNumber(this.editClientModel.clientProfile.pensionYear, 2000, 2061);
    // this.validateString(this.editClientModel.clientProfile.retirementState);

    for (var k in this.editClientModel.clientProfile.Spouses) {
      // this.validateNumber(this.editClientModel.clientProfile.clientSpouses[k].maritalStatus, 0, 5);
      this.formatString(this.editClientModel.clientProfile.Spouses[k], 'firstName');
      this.formatString(this.editClientModel.clientProfile.Spouses[k], 'lastName');
      // this.validateNumber(this.editClientModel.clientProfile.clientSpouses[k].gender, 1, 3);
      // this.validateDate(this.editClientModel.clientProfile.clientSpouses[k].dob);
      this.formatCurrency(this.editClientModel.clientProfile.Spouses[k], 'currentIncome');
      this.formatCurrency(this.editClientModel.clientProfile.Spouses[k], 'pension');
      this.formatCurrency(this.editClientModel.clientProfile.Spouses[k], 'pia');
      // this.validateNumber(this.editClientModel.clientProfile.clientSpouses[k].pensionYear, 2000, 2061);
      // this.validateNumber(this.editClientModel.clientProfile.clientSpouses[k].pensionMonth, 1, 13);
      // this.validateNumber(this.editClientModel.clientProfile.clientSpouses[k].substantialEarningYears, 1, 400000);
      // this.validateNumber(this.editClientModel.clientProfile.clientSpouses[k].retirementAge, 1, 71);
      // this.validateString(this.editClientModel.clientProfile.clientSpouses[k].retirementState);

      // this.editClientModel.clientProfile.Spouses[k].gender = this.editClientModel.clientProfile.Spouses[k].gender === 'Male' ? 1 : 2;

    }
  }

  submitSupportTicket(subject, message) {
    this.snackBarService.add('Thank you for submitting a ticket. A support specialist will be in touch.', 0);
    this.close();

    // //console.log(subject.value)

    var SupportModel = {
      AdvisorID: Number(this.advisor.ID),
      OrgID: Number(this.advisor.OrganizationID),
      Subject: subject.value.toString(),
      Message: message.value.toString(),
    }

    // //console.log(SupportModel);

    this.globalService.createSupportTicket(SupportModel)
      .subscribe(
        data => { },
        error => this.error = <any>error);
  }

  public profileImage = localStorage.getItem('profilePhotoPath') && localStorage.getItem('profilePhotoPath').length > 1 ? 'https://hvswebuat1.hvsfinancial.com/portal/shared/' + localStorage.getItem('profilePhotoPath') : 'https://hvswebuat1.hvsfinancial.com/portal/assets/images/users/anon_user.png';
  public logoImage = localStorage.getItem('logoPhotoPath') && localStorage.getItem('logoPhotoPath').length > 1 ? 'https://hvswebuat1.hvsfinancial.com/portal/shared/' + localStorage.getItem('logoPhotoPath') : 'https://hvswebuat1.hvsfinancial.com/assets/images/temp/logo.png';
  public userRole = localStorage.getItem('roleId');

  uploadProfilePicture(e) {
    let file: File = e.target.files[0];
    let formData: FormData = new FormData();
    var date = new Date().getTime() / 1000;
    // //console.log(file.name.substring(file.name.lastIndexOf('.'), file.name.length));
    formData.append('uploadFile', file, file.name);
    formData.append('Email', this.advisor.Email);
    formData.append('UserID', this.advisor.ID.toString());

    ////console.log(formData);
    this.globalService.saveProfileImage(formData)
      .subscribe(
        data => {
          ////console.log(data._body); 
          localStorage.setItem('profilePhotoPath', data._body);
          this.profileImage = "https://hvswebuat1.hvsfinancial.com/portal/shared/" + localStorage.getItem('profilePhotoPath');
        },
        error => this.error = <any>error);

  }

  public advisorTemp: any = {};

  updateAdvisor(advisor) {


    // public int UserID { get; set; }
    // public int RoleID { get; set; }
    // public string Username { get; set; }
    // public string Password { get; set; }
    // public int OrganizationID { get; set; }
    // public string FirstName { get; set; }
    // public string LastName { get; set; }
    // public string Address { get; set; }
    // public string Address2 { get; set; }
    // public string State { get; set; }
    // public string City { get; set; }
    // public string Zip { get; set; }
    // public string Email { get; set; }
    // public string Phone { get; set; }
    // public int AdvisorID { get; set; }
    // public int UserType { get; set; }


    var UserModel = {
      UserID: this.advisor.ID,
      FirstName: advisor.FirstName,
      LastName: advisor.LastName,
      Phone: advisor.Phone,
    }

    var validation = this.validateEditProfile(UserModel);

    if (!validation.status) {
      this.snackBarService.add('Please make sure your ' + validation.message, 1);
    } else {
      this.globalService.updateAdvisor(UserModel)
        .subscribe(
          data => {
            if (data) {
              localStorage.setItem('firstName', UserModel.FirstName);
              localStorage.setItem('lastName', UserModel.LastName);
            }

            this.snackBarService.add('Your profile has been updated.', 0);
            this.close();
          },
          error => {
            this.error = <any>error;
            this.close();
          });
    }
  }

  validateEditProfile(UserModel) {
    var result = { status: true, message: '' };
    if (UserModel.Phone.length < 10) {
      result.message = 'phone number meets this format (xxx) xxx-xxxx.';
      result.status = false;
    } else if (!this.validateString(UserModel.FirstName, true) || !this.validateString(UserModel.LastName, true)) {
      result.message = 'first name or last name contains no numbers.';
      result.status = false;
    }
    ////console.log(result);
    return result;
  }

  uploadOrgLogo(e) {
    let file: File = e.target.files[0];
    let formData: FormData = new FormData();
    var date = new Date().getTime() / 1000;
    // //console.log(file.name.substring(file.name.lastIndexOf('.'), file.name.length));
    formData.append('uploadFile', file, this.advisor.OrganizationID + '_' + date + '_logo' + file.name.substring(file.name.lastIndexOf('.'), file.name.length));
    formData.append('Email', this.advisor.Email);
    formData.append('UserID', this.advisor.ID.toString());

    ////console.log(formData);
    this.globalService.uploadOrgLogo(formData)
      .subscribe(
        data => {
          ////console.log(data._body); 
          localStorage.setItem('logoPhotoPath', data._body);
          this.logoImage = "https://hvswebuat1.hvsfinancial.com/portal/shared/" + localStorage.getItem('logoPhotoPath');
        },
        error => this.error = <any>error);
  }

  // getPIA(years) {
  //   var PIACalculator = {
  //     currentAge: 43,
  //     earningYear: [
  //       { Year: 2012, ActualEarnings: 100000, Age: 37 },
  //       { Year: 2013, ActualEarnings: 100000, Age: 38 },
  //       { Year: 2014, ActualEarnings: 100000, Age: 39 },
  //       { Year: 2015, ActualEarnings: 100000, Age: 40 },
  //       { Year: 2016, ActualEarnings: 100000, Age: 41 },
  //       { Year: 2017, ActualEarnings: 100000, Age: 42 },
  //       { Year: 2018, ActualEarnings: 100000, Age: 43 }
  //     ]
  //   };

  //   this.globalService.getPIA(PIACalculator)
  //   .subscribe(
  //     data => { 
  //       //console.log(data._body); 
  //     },
  //     error => this.error = <any>error);
  // }


  // formatPIAYearV2(model, isClient) {
  //   var startYear = model.PIAYears.StartYear;
  //   var endYear = model.PIAYears.EndYear;

  //   // //console.log(model);
  //   // //console.log(this.clientModal);

  //   model.PIAYears.Years = [];
  //   if (endYear > startYear) {
  //     for (var i = 0; i < endYear - startYear + 1; i++) {
  //       model.PIAYears.Years.push(
  //         {
  //           Year: Number(model.PIAYears.StartYear) + i,
  //           ActualEarnings: this.formatCurrencyV2(0),
  //         }
  //       );
  //     }
  //   }
  // }

  formatPIAYearV2(model, isSpouse) {
    var startYear = isSpouse ? model.PIAYears.startYear : model.PIAYears.StartYear;
    var endYear = isSpouse ? model.PIAYears.endYear : model.PIAYears.EndYear;
    var currentAge = isSpouse ? this.calculateAge(this.clientModelV2.maritalStatus.dobStr) : this.calculateAge(this.clientModelV2.generalInformation.dobStr);
    var year = new Date().getFullYear();
    
    if (isSpouse)
      model.PIAYears.years = [];
    else
      model.PIAYears.Years = [];

    if (endYear > startYear) {
      for (var i = 0; i < endYear - startYear + 1; i++) {
        if (isSpouse) {

          model.PIAYears.years.push(
            {
              Year: Number(model.PIAYears.startYear) + i,
              Age: Number(startYear) > year ? Math.abs(endYear - year) + currentAge + i : currentAge - Math.abs(startYear - year) + i,
              ActualEarnings: this.formatCurrencyV2(0),
            }
          );
        } else {
          model.PIAYears.Years.push(
            {
              Year: Number(model.PIAYears.StartYear) + i,
              Age: Number(startYear) > year ? Math.abs(endYear - year) + currentAge + i : currentAge - Math.abs(startYear - year) + i,
              ActualEarnings: this.formatCurrencyV2(0),
            }
          );
          ////console.log('yo', model);
        }
      }
    }
  }


  formatPIAYear(model, client) {
    ////console.log(model, client);
    var startYear = client ? model.clientProfile.PIAYears.StartYear.match(/\d/g) : model.PIAYears.StartYear.match(/\d/g);
    var endYear = client ? model.clientProfile.PIAYears.EndYear.match(/\d/g) : model.PIAYears.EndYear.match(/\d/g);
    var year = new Date().getFullYear();

    var currentAge = client ? this.calculateAge(model.client.DOB) : this.calculateAge(model.dob);

    if (client) {
      model.clientProfile.PIAYears.StartYear = startYear.join('').substring(0, 4);
      model.clientProfile.PIAYears.EndYear = endYear.join('').substring(0, 4);

      if (model.clientProfile.PIAYears.StartYear.length === 4 && model.clientProfile.PIAYears.EndYear.length === 4) {
        model.clientProfile.PIAYears.Years = [];
        for (var i = 0; i < model.clientProfile.PIAYears.EndYear - model.clientProfile.PIAYears.StartYear + 1; i++) {
          model.clientProfile.PIAYears.Years.push(
            {
              Year: Number(model.clientProfile.PIAYears.StartYear) + i,
              ActualEarnings: this.formatCurrencyV2(0),
              Age: Number(model.clientProfile.PIAYears.StartYear) > year ? Math.abs(model.clientProfile.PIAYears.StartYear - year) + currentAge + i : currentAge - Math.abs(model.clientProfile.PIAYears.StartYear - year) + i
            }
          );
        }
      }

    } else {
      model.PIAYears.StartYear = startYear.join('').substring(0, 4);
      model.PIAYears.EndYear = endYear.join('').substring(0, 4);

      if (model.PIAYears.StartYear.length === 4 && model.PIAYears.EndYear.length === 4) {
        model.PIAYears.Years = [];
        for (var i = 0; i < model.PIAYears.EndYear - model.PIAYears.StartYear + 1; i++) {
          model.PIAYears.Years.push(
            {
              Year: Number(model.PIAYears.StartYear) + i,
              ActualEarnings: this.formatCurrencyV2(0),
              Age: Number(model.PIAYears.StartYear) > year ? Math.abs(model.PIAYears.StartYear - year) + currentAge + i : currentAge - Math.abs(model.PIAYears.StartYear - year) + i
            }
          );
        }
      }
    }


    ////console.log(model);
  }

  calculateAge(birthday) {
    birthday = new Date(birthday);
    var ageDifMs = Date.now() - birthday;
    var ageDate = new Date(ageDifMs);

    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  calculatePIAV2(model, isSpouse) {
    var PIACalculator = {
      currentAge: Number(this.calculateAge(!isSpouse ? model.generalInformation.dobStr : model.maritalStatus.dobStr)),
      earningYear: this.removePIACurrency(!isSpouse ? model.financialInformation.PIAYears.Years : model.maritalStatus.PIAYears.years)
    }

    ////console.log(PIACalculator);

    this.globalService.getPIA(PIACalculator)
      .subscribe(
        data => {
          if (isSpouse) {
            model.maritalStatus.pia = this.formatCurrencyV2(data);
            model.maritalStatus.PIAYears.years = this.addPIACurrency(model.maritalStatus.PIAYears.years);
            this.validateFields(3);
          } else {
            model.financialInformation.pia = this.formatCurrencyV2(data);
            model.financialInformation.PIAYears.Years = this.addPIACurrency(model.financialInformation.PIAYears.Years);
            this.validateFields(1);
          }

        },
        error => this.error = <any>error);
  }

  calculatePIA(model, client) {
    ////console.log(model, client);
    var PIACalculator = {};

    if (client) {
      PIACalculator = {
        currentAge: Number(this.calculateAge(model.client.DOB)),
        earningYear: this.removePIACurrency(model.clientProfile.PIAYears.Years)
      }
    } else {
      PIACalculator = {
        currentAge: Number(this.calculateAge(model.dob)),
        earningYear: this.removePIACurrency(model.PIAYears.Years)
      }
    }

    ////console.log(PIACalculator);
    this.globalService.getPIA(PIACalculator)
      .subscribe(
        data => {
          ////console.log(data); 
          if (client) {
            model.clientProfile.PIA = this.formatCurrencyV2(data);
            model.clientProfile.PIAYears.Years = this.addPIACurrency(model.clientProfile.PIAYears.Years);
          } else {
            model.pia = this.formatCurrencyV2(data);
            model.PIAYears.Years = this.addPIACurrency(model.PIAYears.Years);
          }


        },
        error => this.error = <any>error);
  }

  removePIACurrency(years) {
    var temp = [];

    for (var item in years) {
      temp.push(years[item]);
      temp[item].ActualEarnings = Number(temp[item].ActualEarnings.replace(/,/g, "").replace("$", ""));
    }

    return temp;
  }

  addPIACurrency(years) {
    var temp = [];

    for (var item in years) {
      temp.push(years[item]);
      temp[item].ActualEarnings = this.formatCurrencyV2(temp[item].ActualEarnings)
    }

    return temp;
  }

  recalcLEV2(model, index, firstLoad = false) {
    var LEObject;
    ////console.log('passsed model: ', model)

    if (index === 0) {
      if (model.generalInformation.dobStr && model.generalInformation.gender) {
        LEObject = {
          gender: Number(model.generalInformation.gender),
          age: this.calculateAge(model.generalInformation.dobStr),
          healthConditions: {
            HCC: model.healthInformation.HCC ? 1 : 0,
            HCCD: model.healthInformation.HCCD ? 1 : 0,
            HCHBP: model.healthInformation.HCHBP ? 1 : 0,
            HCHC: model.healthInformation.HCHC ? 1 : 0,
            HCT: model.healthInformation.HCT ? 1 : 0,
            HCT2D: model.healthInformation.HCT2D ? 1 : 0,
          }
        }
      }
    } else if (index === 3) {
      if (model.maritalStatus.dobStr && model.maritalStatus.gender) {
        LEObject = {
          gender: Number(model.maritalStatus.gender),
          age: this.calculateAge(model.maritalStatus.dobStr),
          healthConditions: {
            HCC: model.maritalStatus.HCC ? 1 : 0,
            HCCD: model.maritalStatus.HCCD ? 1 : 0,
            HCHBP: model.maritalStatus.HCHBP ? 1 : 0,
            HCHC: model.maritalStatus.HCHC ? 1 : 0,
            HCT: model.maritalStatus.HCT ? 1 : 0,
            HCT2D: model.maritalStatus.HCT2D ? 1 : 0,
          }
        }
      }
    }

    ////console.log('le object: ',LEObject);
    this.globalService.getLE(LEObject)
      .subscribe(
        le => {
          if (index === 0) {
            model.healthInformation.lifeExpectancy = le;
          } else if (index === 3) {
            model.maritalStatus.lifeExpectancy = le;
          }

          this.validateAllFields();
          ////console.log(this.client.clientProfile);
          if (this.client.clientProfile && firstLoad)
            this.setActiveErrorPage();

          ////console.log(model.healthInformation) 
        },
        error => { this.error = <any>error; });


  }

  recalcLE(model, type) {
    // //console.log(model);
    // //console.log('asd')

    if (model.dob) { // hack to check if it's a partner (clients dont have alive property)
      var LEObject;

      if (this.validateDate(model.dob, true) && model.gender) {
        LEObject = {
          gender: Number(model.gender),
          age: this.calculateAge(model.dob),
          healthConditions: {
            HCC: model.HCC ? 1 : 0,
            HCCD: model.HCCD ? 1 : 0,
            HCHBP: model.HCHBP ? 1 : 0,
            HCHC: model.HCHC ? 1 : 0,
            HCT: model.HCT ? 1 : 0,
            HCT2D: model.HCT2D ? 1 : 0,
          },
        }

        this.globalService.getLE(LEObject)
          .subscribe(
            le => {
              if (!type)
                model.LifeExpectancy = le;
              else if (type === 'client')
                this.clientModelV2.healthInformation.lifeExpectancy = le;
            },
            error => this.error = <any>error);
      }
    } else {
      if (model.client && this.validateDate(model.client.DOB, true) && (model.client.GenderID || model.client.gender)) {
        LEObject = {
          gender: model.client.GenderID || model.client.gender,
          age: this.calculateAge(model.client.DOB),
          healthConditions: {
            HCC: model.clientProfile.HCC ? 1 : 0,
            HCCD: model.clientProfile.HCCD ? 1 : 0,
            HCHBP: model.clientProfile.HCHBP ? 1 : 0,
            HCHC: model.clientProfile.HCHC ? 1 : 0,
            HCT: model.clientProfile.HCT ? 1 : 0,
            HCT2D: model.clientProfile.HCT2D ? 1 : 0,
          },
        }

        this.globalService.getLE(LEObject)
          .subscribe(
            le => { model.clientProfile.LifeExpectancy = le },
            error => this.error = <any>error);
      }
    }

    ////console.log(LEObject);
  }

  assignLead(leadRelationshipId, advisor) {
    this.globalService.assignLead(leadRelationshipId, advisor.c.ID)
      .subscribe(
        resp => {
          this.snackBarService.add("Lead has been assigned to: " + advisor.c.FirstName + ' ' + advisor.c.LastName, 0);
          this.close();
        },
        error => this.error = <any>error);
  }

  formatDate(date) {
    date = new Date(date);
    return date > 1 / 1 / 1900 ? (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear() : '--';
  }

  handleEsc(e) {
    ////console.log(e.keyCode);
    if (e.keyCode == 27) {
      // //console.log('enter');
      this.close();
    }
  }



}
